<!-- 幸运抽奖 -->
<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime="activityStartTime"
            :defaultActivityEndTime="activityEndTime"
            :plusObject.sync="ruleForm.ruleDTO.plusObject"
            :openCardStartTime.sync="ruleForm.ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleForm.ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <jd-title label="抽卡机会" type="bold"></jd-title>
          <el-form-item label="获取抽奖机会方式:" required>
            <el-radio
              v-model="ruleForm.ruleDTO.cardDrawType"
              :disabled="activityData.isStart"
              :label="0"
              >任务赠送</el-radio
            >
            <el-radio
              v-model="ruleForm.ruleDTO.cardDrawType"
              :disabled="activityData.isStart"
              :label="1"
              >消耗积分</el-radio
            >
          </el-form-item>
          <el-form-item
            label="免费赠送:"
            v-if="ruleForm.ruleDTO.cardDrawType == 0"
          >
            <el-radio
              :label="0"
              v-model="cardDrawGiveType"
              :disabled="activityData.isStart"
            >
              首次赠送
              <el-input
                v-model.number="ruleForm.ruleDTO.firstGiveTimes"
                placeholder="请输入"
                @input="
                  ruleForm.ruleDTO.firstGiveTimes = getNumberData(
                    1,
                    $event,
                    0,
                    1
                  )
                "
                style="width: 80px"
                :disabled="activityData.isStart || cardDrawGiveType == 1"
              ></el-input>
              次
            </el-radio>
            <el-radio
              :label="1"
              v-model="cardDrawGiveType"
              :disabled="activityData.isStart"
            >
              每天
              <el-input
                v-model.number="ruleForm.ruleDTO.everyDayGiveTimes"
                placeholder="请输入"
                @input="
                  ruleForm.ruleDTO.everyDayGiveTimes = getNumberData(
                    1,
                    $event,
                    0,
                    1
                  )
                "
                style="width: 80px"
                :disabled="activityData.isStart || cardDrawGiveType == 0"
              ></el-input>
              次
            </el-radio>
          </el-form-item>
          <el-form-item label="积分抽奖:" required v-else>
            用户消耗
            <el-input
              v-model.number="ruleForm.ruleDTO.consumePoint"
              :disabled="activityData.isStart"
              placeholder="请输入"
              style="width: 80px"
              @input="
                ruleForm.ruleDTO.consumePoint = getNumberData(1, $event, 0, 1)
              "
            ></el-input>
            积分抽卡一次
          </el-form-item>
          <el-form-item
            label="任务获取:"
            v-if="ruleForm.ruleDTO.cardDrawType == 0"
          >
            <div class="task-btn-wrap">
              <jd-button v-if="!backgroundOpacity" type="blue" @click="addTask"
                >+添加任务</jd-button
              >
            </div>
            <jd-table
              v-if="taskDataList.length > 0"
              :tableData="taskDataList"
              style="width: 100%"
            >
              <el-table-column label="任务" width="80px">
                <template slot-scope="scope">
                  <span>任务{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务类型">
                <template slot-scope="scope">
                  <span>{{ getTaskType(scope.row.type) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务条件" prop="condition">
                <template slot-scope="scope">
                  <span style="white-space: pre">{{
                    getCondition(scope.row)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务次数" prop="count">
                <template slot-scope="scope">
                  <span>{{ getCount(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <jd-button
                    :disabled="activityData.isStart"
                    type="blueText"
                    style="margin-right: 8px"
                    @click="editTask(scope.row, false)"
                    >修改</jd-button
                  >
                  <jd-button
                    type="blueText"
                    style="margin-right: 8px"
                    @click="editTask(scope.row, true)"
                    >查看</jd-button
                  >
                  <jd-button
                    :disabled="backgroundOpacity"
                    type="blueText"
                    style="margin-right: 8px"
                    @click="deleteTask(scope.row)"
                    >删除</jd-button
                  >
                  <jd-button
                    :disabled="backgroundOpacity"
                    type="blueText"
                    style="margin-right: 8px"
                    @click="upTask(scope.$index)"
                    v-if="scope.$index != 0"
                    >上移</jd-button
                  >
                  <jd-button
                    :disabled="backgroundOpacity"
                    type="blueText"
                    @click="downTask(scope.$index)"
                    v-if="scope.$index != taskDataList.length - 1"
                    >下移</jd-button
                  >
                </template>
              </el-table-column>
            </jd-table>
          </el-form-item>
          <!-- 卡片设置 -->
          <jd-title label="卡片设置" type="bold"></jd-title>
          <el-form-item label="集卡类型:" required>
            <el-radio-group
              v-model="ruleForm.ruleDTO.collectCardType"
              :disabled="activityData.isStart"
              @change="changeCardType"
            >
              <el-radio :label="0">集卡</el-radio>
              <el-radio :label="1">集碎片</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="卡片设置:" required>
            <div class="task-btn-wrap">
              <jd-button
                :disabled="activityData.isStart"
                type="blue"
                @click="addCard"
                >+添加图片({{ collectCardList.length }}/10)</jd-button
              >
            </div>
            <div class="card-list-container">
              <div
                v-for="(item, index) in collectCardList"
                :key="index"
                class="card-item"
              >
                <div class="upload-container">
                  <el-upload
                    :class="[
                      'img-uploader',
                      item.fileList.length ? 'hide-upload-btn' : '',
                    ]"
                    ref="upload"
                    action="/jd-hd-web/image/upload"
                    :file-list="item.fileList"
                    list-type="picture-card"
                    :disabled="activityData.isStart"
                    :on-success="
                      (file) => {
                        return handleChange(file, item);
                      }
                    "
                    :on-remove="
                      (file, fileList) => {
                        return handleRemove(file, fileList, item);
                      }
                    "
                  >
                    <i class="el-icon-plus img-uploader-icon"></i>
                  </el-upload>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/card-delete-icon.svg"
                    class="del-icon"
                    alt=""
                    v-if="collectCardList.length > 0 && !activityData.isStart"
                    @click="deleteCard(item, index)"
                  />
                </div>
                <div class="mt8">
                  <el-input
                    v-model="item.title"
                    maxlength="10"
                    class="input-box"
                    show-word-limit
                    placeholder="名称 最多10字"
                    :disabled="activityData.isStart"
                  ></el-input>
                </div>
                <div class="flex-spc-x mtb8">
                  <span>概率</span>
                  <el-input
                    class="num-input"
                    @input="
                      (item.percentage = getNumberData(1, $event, 1, 0)),
                        handleProbabilityInput(item)
                    "
                    v-model.number="item.percentage"
                    :disabled="activityData.isStart"
                  >
                    <template slot="append">%</template>
                  </el-input>
                </div>
                <div class="flex-spc-x w100">
                  <span>数量</span>
                  <el-input
                    class="num-input"
                    @input="
                      item.cardLimitNumber = getNumberData(1, $event, 0, 1)
                    "
                    v-model.number.trim="item.cardLimitNumber"
                    :disabled="activityData.isStart"
                  >
                    <template slot="append">张</template>
                  </el-input>
                </div>
                <div>
                  <el-radio-group
                    v-model="item.isSelect"
                    :disabled="activityData.isStart"
                  >
                    <el-radio
                      :label="index"
                      @click.native.prevent="handleKeyCardClick(index, item)"
                      >关键卡</el-radio
                    >
                  </el-radio-group>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="关键卡开启时间:"
            required
            v-if="selectedIndex != -1"
          >
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.ruleDTO.keyCardStartTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                :picker-options="cardStartLimit"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.ruleDTO.keyCardEndTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                :picker-options="cardEndLimit"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart"
                @click="clearKeyCardTime()"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
          </el-form-item>
          <el-form-item
            label="每张图的碎片数量:"
            required
            v-if="ruleForm.ruleDTO.collectCardType == 1"
          >
            <el-radio-group
              v-model="ruleForm.ruleDTO.shardNumber"
              :disabled="activityData.isStart"
            >
              <el-radio :label="2">2张</el-radio>
              <el-radio :label="4">4张</el-radio>
              <el-radio :label="6">6张</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="重复抽中配置:"
            v-if="ruleForm.ruleDTO.collectCardType == 1"
          >
            <el-checkbox
              v-model="ruleForm.ruleDTO.isRepeatRule"
              :disabled="activityData.isStart"
              >用户在抽中</el-checkbox
            >
            <el-input
              class="num-style"
              style="width: 90px"
              v-model="ruleForm.ruleDTO.repeatNumber"
              :disabled="!ruleForm.ruleDTO.isRepeatRule || activityData.isStart"
              @input="ruleForm.ruleDTO.repeatNumber = limitInputFn($event)"
              placeholder="请输入"
            ></el-input>
            <span>张碎片前不会重复抽中已有碎片;</span>
          </el-form-item>
          <el-form-item label="是否抽中谢谢参与:" required>
            <el-radio-group
              v-model="ruleForm.ruleDTO.isKeyCardThanks"
              :disabled="activityData.isStart"
            >
              <el-radio :label="0" :disabled="selectedIndex != -1">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="mb12">
            <jd-tip>
              <div>
                1、配置完成卡片后参与活动需集齐全部卡片才可获得一次抽奖&兑换奖品机会；
              </div>
              <div>
                2、所有卡片概率相加不得大于100%，开启抽中谢谢参与时，少于100%时剩余概率奖抽中“谢谢参与”，未开启抽中谢谢参与时，所有卡片概率相加需等于100%；
              </div>
              <div>
                3、配置卡片数量为用户同一卡片最高重复抽中数量，开启抽中谢谢参与后，指定卡片抽完数量后，其卡片概率奖成为抽中谢谢参与的概率；
              </div>
              <div>
                4、关键卡仅可选择一致也可不选择，选择关键卡后，用户仅在关键卡开启时间可抽中关键卡，其余时间将关键卡抽中概率作为谢谢参与的概率；
              </div>
            </jd-tip>
          </div>

          <jd-title label="奖品设置" type="bold"></jd-title>
          <el-form-item label="获取奖品类型:" required>
            <el-radio-group
              v-model="ruleForm.ruleDTO.prizeType"
              :disabled="activityData.isStart"
              @change="changePrizeType"
            >
              <el-radio :label="0">集卡抽奖</el-radio>
              <el-radio :label="1">集卡兑换</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="ruleForm.ruleDTO.prizeType == 0">
            <el-form-item label="抽奖和中奖限制:">
              <div class="limit">
                <p>
                  每人<span class="c">每天</span>最多抽奖次数
                  <el-input
                    v-model.number="
                      ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber
                    "
                    placeholder="请输入"
                    @input="
                      ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber =
                        getNumberData(1, $event, 0, 1)
                    "
                    style="width: 80px"
                    :disabled="activityData.isStart"
                  ></el-input>
                  次, 活动期间<span class="c">累计抽奖</span>最多
                  <el-input
                    v-model.number="
                      ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber
                    "
                    placeholder="请输入"
                    @input="
                      ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber =
                        getNumberData(1, $event, 0, 1)
                    "
                    style="width: 80px"
                    :disabled="activityData.isStart"
                  ></el-input>
                  次,
                </p>
                <p>
                  活动期间每人<span class="c">每天</span>中奖不超过
                  <el-input
                    v-model.number="
                      ruleForm.ruleDTO.lotteryRule.oneDayMaxRewardNumber
                    "
                    placeholder="请输入"
                    style="width: 80px"
                    @input="
                      ruleForm.ruleDTO.lotteryRule.oneDayMaxRewardNumber =
                        getNumberData(1, $event, 0, 1)
                    "
                    :disabled="activityData.isStart"
                  ></el-input>
                  次, <span class="c">累计</span>中奖不超过
                  <el-input
                    v-model.number="
                      ruleForm.ruleDTO.lotteryRule.totalMaxRewardNumber
                    "
                    placeholder="请输入"
                    style="width: 80px"
                    @input="
                      ruleForm.ruleDTO.lotteryRule.totalMaxRewardNumber =
                        getNumberData(1, $event, 0, 1)
                    "
                    :disabled="activityData.isStart"
                  ></el-input>
                  次,
                </p>
                <div style="width: 520px">
                  <jd-tip>
                    此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
                  </jd-tip>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="统计规则:">
              <el-select
                v-model="ruleForm.ruleDTO.lotteryRule.statisticsRule"
                placeholder="请选择"
                style="width: 400px"
                :disabled="activityData.isStart"
              >
                <el-option label="集满一套卡片即可兑换一次抽奖" :value="0">
                </el-option>
                <el-option
                  v-if="ruleForm.ruleDTO.collectCardType == 1"
                  label="集满一张卡片即可兑换一次抽奖（仅集卡类型为集碎片）"
                  :value="1"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item label="兑换奖品限制:" required>
              <el-radio-group
                v-model="ruleForm.ruleDTO.exchangeRule.exchangeType"
                :disabled="activityData.isStart"
                @change="handleChangeExchangeType"
              >
                <el-radio :label="0">仅可兑换一次</el-radio>
                <el-radio :label="1">活动期间每人可兑换</el-radio>
              </el-radio-group>
              <el-input
                class="input-limit ml8"
                placeholder="不限制"
                :disabled="
                  ruleForm.ruleDTO.exchangeRule.exchangeType == 0 ||
                  activityData.isStart
                "
                v-model="ruleForm.ruleDTO.exchangeRule.exchangeNumber"
              ></el-input>
              <span class="tip-red ml8">不填默认为不限制次数</span>
            </el-form-item>
            <el-form-item label="奖品规则:" required>
              <el-radio-group
                v-model="ruleForm.ruleDTO.exchangeRule.prizeRule"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">统一奖品</el-radio>
                <el-radio :label="1">阶梯奖品</el-radio>
              </el-radio-group>
              <el-form-item
                label="统计规则:"
                required
                label-width="90px"
                v-if="ruleForm.ruleDTO.exchangeRule.prizeRule == 0"
              >
                <el-select
                  v-model="ruleForm.ruleDTO.exchangeRule.statisticsRule"
                  placeholder="请选择"
                  style="width: 400px"
                  :disabled="activityData.isStart"
                >
                  <el-option label="集满一套卡片即可兑换一次奖品" :value="0">
                  </el-option>
                  <el-option
                    v-if="ruleForm.ruleDTO.collectCardType == 1"
                    label="集满一张卡片即可兑换一次奖品（仅集卡类型为集碎片）"
                    :value="1"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="奖品设置:"
                label-width="90px"
                required
                v-if="ruleForm.ruleDTO.exchangeRule.prizeRule == 0"
              >
                <jd-table
                  :tableData="bigTurntableDrawPrizeDTOS"
                  :style="{ width: activityData.isStart ? '100%' : '1100px' }"
                >
                  <el-table-column label="奖品类型" width="120">
                    <template slot-scope="scope">
                      {{ getPrizeTypeName(scope.row.prizeType) }}
                      <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                      <span v-if="scope.row.prizeType == 2">京豆</span>
                      <span v-if="scope.row.prizeType == 3">实物</span>
                      <span v-if="scope.row.prizeType == 4">店铺积分</span>
                      <span v-if="scope.row.prizeType == 5">京东E卡</span>
                      <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                      <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                      <span v-if="scope.row.prizeType == 8">现金红包</span>
                      <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                      <span v-if="scope.row.prizeType == 10">礼品卡</span>
                      <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品价值" width="100" prop="price">
                  </el-table-column>
                  <el-table-column label="奖品图片" width="160">
                    <template slot-scope="scope">
                      <img
                        v-if="scope.row.logo"
                        :src="scope.row.logo"
                        style="width: 56px; height: 56px"
                      />
                    </template>
                  </el-table-column>

                  <el-table-column label="奖品名称" width="265">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.title"
                        maxlength="15"
                        show-word-limit
                        style="width: 240px"
                      ></el-input>
                    </template>
                  </el-table-column>

                  <el-table-column label="奖品数量" width="180">
                    <template slot-scope="scope">
                      <el-input
                        v-model.number="scope.row.totalAmount"
                        @input.native="
                          (e) =>
                            (scope.row.totalAmount = checkputn(
                              e,
                              scope.row,
                              'jindou'
                            ))
                        "
                        placeholder="请输入"
                        @input="
                          (scope.row.totalAmount = getNumberData(
                            1,
                            $event,
                            0,
                            1,
                            999999
                          )),
                            prizeNum(scope.row)
                        "
                        @blur="beAdd(scope.row)"
                        :disabled="
                          (activityData.isStart && !scope.row.minNum) ||
                          activityData.isStart
                        "
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="剩余库存"
                    width="80"
                    v-if="activityData.isStart"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.remanentAmount }}
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <div class="flexc-cen-x">
                        <jd-button
                          type="blueText"
                          @click="selectUnifiedPrize(scope.row, scope.$index)"
                          :disabled="activityData.isStart"
                          >选择奖品</jd-button
                        >
                        <el-upload
                          class="label-left"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          :before-upload="beforeUpload"
                          :on-success="(res) => handleUpload(res, scope.row)"
                          :disabled="activityData.isStart"
                        >
                          <jd-button
                            type="blueText"
                            :disabled="activityData.isStart"
                            >上传图片</jd-button
                          >
                        </el-upload>
                        <jd-button
                          class="label-left"
                          type="blueText"
                          :disabled="activityData.isStart"
                          v-if="bigTurntableDrawPrizeDTOS.length > 1"
                          @click="delUnifiedPrize(scope.$index)"
                          >删除</jd-button
                        >
                        <jd-button
                          style="margin-left: 8px !important"
                          type="blueText"
                          v-if="activityData.isStart && scope.row.title"
                          @click="
                            itemAddNum(
                              'bigTurntableDrawPrizeDTOS',
                              scope.$index
                            )
                          "
                          >增加奖品数量</jd-button
                        >
                      </div>
                    </template>
                  </el-table-column>
                </jd-table>
                <jd-button type="blue" class="mt8" @click="addUnifiedPrize"
                  >+添加奖品（{{
                    bigTurntableDrawPrizeDTOS.length
                  }}/4）</jd-button
                >
                <span class="tip-red ml8"
                  >注：添加多个商品时，用户每次仅能选择其一进行兑换；</span
                >
              </el-form-item>
            </el-form-item>
            <el-form-item
              label="阶梯设置:"
              required
              v-if="ruleForm.ruleDTO.exchangeRule.prizeRule == 1"
            >
              <jd-button type="blue" @click="addStepPrize"
                >+阶梯（{{ stepList.length }}/5）</jd-button
              >
              <div
                v-for="(item, index) in stepList"
                :key="index"
                class="ladder-box"
              >
                <div
                  class="el-icon-delete delete-icon"
                  v-if="stepList.length > 1"
                  @click="deleteStep(index)"
                ></div>
                <div>阶梯{{ index + 1 }}</div>
                <el-form-item label="统计规则:">
                  <div class="flexc-cen-x">
                    <el-radio
                      v-model="item.statisticsRule"
                      :label="0"
                      @change="changeRule(item)"
                      >集满</el-radio
                    >
                    <el-input
                      v-model="item.collectSetNum"
                      :disabled="item.statisticsRule == 1"
                      class="input-limit"
                    ></el-input>
                    <span class="ml8">套卡片可兑换</span>
                  </div>
                  <div
                    class="flexc-cen-x mt8"
                    v-if="ruleForm.ruleDTO.collectCardType == 1"
                  >
                    <el-radio
                      v-model="item.statisticsRule"
                      :label="1"
                      @change="changeRule(item, $event)"
                      >集满</el-radio
                    >
                    <el-input
                      v-model="item.collectCardNum"
                      class="input-limit"
                      :disabled="item.statisticsRule == 0"
                    ></el-input>
                    <span class="ml8"
                      >张卡片可兑换（仅限集卡类型为集碎片）</span
                    >
                  </div>
                </el-form-item>
                <el-form-item label="奖品设置:" required>
                  <jd-table
                    :tableData="item.stepPrizeDTO"
                    :style="{
                      width: activityData.isStart ? '1180px' : '1100px',
                    }"
                  >
                    <el-table-column label="奖品类型" width="120">
                      <template slot-scope="scope">
                        {{ getPrizeTypeName(scope.row.prizeType) }}
                        <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                        <span v-if="scope.row.prizeType == 2">京豆</span>
                        <span v-if="scope.row.prizeType == 3">实物</span>
                        <span v-if="scope.row.prizeType == 4">店铺积分</span>
                        <span v-if="scope.row.prizeType == 5">京东E卡</span>
                        <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                        <span v-if="scope.row.prizeType == 7"
                          >京东PLUS会员</span
                        >
                        <span v-if="scope.row.prizeType == 8">现金红包</span>
                        <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                        <span v-if="scope.row.prizeType == 10">礼品卡</span>
                        <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span> -->
                      </template>
                    </el-table-column>
                    <el-table-column label="奖品价值" width="100" prop="price">
                    </el-table-column>
                    <el-table-column label="奖品图片" width="150">
                      <template slot-scope="scope">
                        <img
                          v-if="scope.row.logo"
                          :src="scope.row.logo"
                          style="width: 56px; height: 56px"
                        />
                      </template>
                    </el-table-column>

                    <el-table-column label="奖品名称" width="265">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.title"
                          maxlength="15"
                          show-word-limit
                          style="width: 240px"
                        ></el-input>
                      </template>
                    </el-table-column>

                    <el-table-column label="奖品数量" width="150">
                      <template slot-scope="scope">
                        <el-input
                          v-model.number="scope.row.totalAmount"
                          @input.native="
                            (e) =>
                              (scope.row.totalAmount = checkputn(
                                e,
                                scope.row,
                                'jindou'
                              ))
                          "
                          placeholder="请输入"
                          @input="
                            (scope.row.totalAmount = getNumberData(
                              1,
                              $event,
                              0,
                              1,
                              999999
                            )),
                              prizeNum(scope.row)
                          "
                          @blur="beAdd(scope.row)"
                          :disabled="
                            (activityData.isStart && !scope.row.minNum) ||
                            activityData.isStart
                          "
                        ></el-input>
                      </template>
                    </el-table-column>
                    <el-table-column label="每日发放限额" width="120">
                      <template slot-scope="scope">
                        <dailyLimitConfig
                          :row="scope.row"
                          :backgroundOpacity="backgroundOpacity"
                          :limitBtnDisabled="backgroundOpacity"
                        ></dailyLimitConfig>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="剩余库存"
                      width="80"
                      v-if="activityData.isStart"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.remanentAmount }}
                      </template>
                    </el-table-column>

                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <div class="flexc-cen-x">
                          <jd-button
                            type="blueText"
                            @click="
                              selectStepPrize(index, scope.row, scope.$index)
                            "
                            :disabled="activityData.isStart"
                            >选择奖品</jd-button
                          >
                          <el-upload
                            class="label-left"
                            action="/jd-hd-web/image/upload"
                            :show-file-list="false"
                            :before-upload="beforeUpload"
                            :on-success="
                              (res) => handleStepUpload(res, scope.row)
                            "
                            :disabled="activityData.isStart"
                          >
                            <jd-button
                              type="blueText"
                              :disabled="activityData.isStart"
                              >上传图片</jd-button
                            >
                          </el-upload>
                          <jd-button
                            class="label-left"
                            type="blueText"
                            :disabled="activityData.isStart"
                            v-if="item.stepPrizeDTO.length > 1"
                            @click="
                              delStepPrize(item.stepPrizeDTO, scope.$index)
                            "
                            >删除</jd-button
                          >
                          <jd-button
                            type="blueText"
                            style="margin-left: 8px !important"
                            v-if="activityData.isStart && scope.row.title"
                            @click="
                              addStepPrizeDTONum(
                                'stepPrizeDTO',
                                index,
                                scope.$index
                              )
                            "
                            >增加奖品数量</jd-button
                          >
                        </div>
                      </template>
                    </el-table-column>
                  </jd-table>
                  <jd-button
                    type="blue"
                    class="mt8"
                    @click="addSigleStepList(item)"
                    :disabled="activityData.isStart"
                    >+添加奖品（{{ item.stepPrizeDTO.length }}/4）</jd-button
                  >
                  <span class="tip-red ml8"
                    >注：添加多个商品时，用户每次仅能选择其一进行兑换；</span
                  >
                </el-form-item>
              </div>
            </el-form-item>
          </div>

          <div v-if="ruleForm.ruleDTO.prizeType == 0">
            <el-form-item required>
              <span slot="label" class="set">奖品设置:</span>
              <div class="termAdd">
                <el-popover placement="right" width="270" trigger="hover">
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/wzsyt.png"
                    alt=""
                  />
                  <span slot="reference">位置示意图</span>
                </el-popover>
                <p>
                  累计中奖率: <span class="add">{{ winningRate }} %</span>
                </p>
              </div>
              <jd-table :tableData="prizeSettingList" style="width: 100%">
                <el-table-column label="位置" width="100">
                  <template slot-scope="scope">
                    <span v-if="scope.row.index == 0">一</span>
                    <span v-if="scope.row.index == 1">二</span>
                    <span v-if="scope.row.index == 2">三</span>
                    <span v-if="scope.row.index == 3">四</span>
                    <span v-if="scope.row.index == 4">五</span>
                    <span v-if="scope.row.index == 5">六</span>
                    <span v-if="scope.row.index == 6">七</span>
                    <span v-if="scope.row.index == 7">八</span>
                  </template>
                </el-table-column>

                <el-table-column label="选择奖品">
                  <template slot-scope="scope">
                    <jd-button
                      :disabled="activityData.isStart"
                      type="blueText"
                      @click="centerVis(scope.row)"
                      >选奖品</jd-button
                    >
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    {{ getPrizeTypeName(scope.row.prizeType) }}
                    <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                    <span v-if="scope.row.prizeType == 2">京豆</span>
                    <span v-if="scope.row.prizeType == 3">实物</span>
                    <span v-if="scope.row.prizeType == 4">店铺积分</span>
                    <span v-if="scope.row.prizeType == 5">京东E卡</span>
                    <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                    <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                    <span v-if="scope.row.prizeType == 8">现金红包</span>
                    <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                    <span v-if="scope.row.prizeType == 10">礼品卡</span>
                    <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span> -->
                  </template>
                </el-table-column>

                <el-table-column label="值" width="80" prop="price">
                </el-table-column>

                <el-table-column label="奖品名称（12字内）" width="299">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.title"
                      maxlength="12"
                      :disabled="scope.row.prizeType == 9"
                      show-word-limit
                      style="width: 240px"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="奖品总数" width="180">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.totalAmount"
                      @input.native="
                        (e) =>
                          (scope.row.totalAmount = checkputn(
                            e,
                            scope.row,
                            'jindou'
                          ))
                      "
                      placeholder="请输入"
                      style="width: 80px"
                      @input="
                        (scope.row.totalAmount = getNumberData(
                          1,
                          $event,
                          0,
                          1
                        )),
                          prizeNum(scope.row)
                      "
                      @blur="beAdd(scope.row)"
                      :disabled="
                        (activityData.isStart && !scope.row.minNum) ||
                        activityData.isStart
                      "
                    ></el-input>
                    份
                  </template>
                </el-table-column>

                <el-table-column
                  label="每日发放限额"
                  width="180"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div
                      style="text-align: center"
                      @click="setLimit(scope.row)"
                    >
                      <jd-button
                        :disabled="activityData.isStart"
                        v-if="
                          !scope.row.dailyLimitType && !scope.row.dailyLimit
                        "
                        type="blueText"
                      >
                        配置
                      </jd-button>
                      <jd-button
                        :disabled="activityData.isStart"
                        v-if="
                          scope.row.dailyLimitType == 0 && scope.row.dailyLimit
                        "
                        type="blueText"
                      >
                        每日发放{{ scope.row.dailyLimit }}份
                      </jd-button>
                      <div v-if="scope.row.dailyLimitType == 1">
                        <div>
                          <jd-button
                            :disabled="activityData.isStart"
                            type="blueText"
                            >闲时发放{{ scope.row.idleLimit }}份</jd-button
                          >
                        </div>
                        <div>
                          <jd-button
                            :disabled="activityData.isStart"
                            type="blueText"
                            >忙时发放{{ scope.row.busyLimit }}份</jd-button
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <!-- @input=" scope.row.percentage = getNumberData( 1, $event, 1, 0, 100 ) " -->
                <el-table-column label="中奖率" width="130">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.percentage"
                      placeholder="请输入"
                      style="width: 90px"
                      @keyup.native="
                        scope.row.percentage = oninput2(
                          scope.row.percentage,
                          scope.$index
                        )
                      "
                      :disabled="
                        !activityData.status
                          ? false
                          : !scope.row.totalAmount
                          ? true
                          : false
                      "
                    ></el-input>
                    %
                  </template>
                </el-table-column>
                <el-table-column label="最多中奖次数" width="130">
                  <template #header>
                    <el-tooltip
                      effect="light"
                      content="当单个用户中奖次数达到设定上限后，后续抽奖不再分配该奖品，系统自动重配其他奖品。"
                      placement="right"
                    >
                      <div>
                        最多中奖次数<i
                          style="color: #ccc"
                          class="el-icon-question"
                        ></i>
                      </div>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.singleMaxWin"
                      placeholder="请输入"
                      style="width: 80px"
                      @input="
                        scope.row.singleMaxWin = getNumberData(
                          1,
                          $event,
                          1,
                          0,
                          9999
                        )
                      "
                      :disabled="
                        !activityData.status || activityData.isCopy
                          ? false
                          : !scope.row.totalAmount
                          ? true
                          : false
                      "
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="图片" width="170">
                  <template slot-scope="scope">
                    <img
                      v-if="scope.row.logo"
                      :src="scope.row.logo"
                      style="width: 56px; height: 56px"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="入会且已购中奖率" width="150">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.memberBuyPercentage"
                      @input="
                        scope.row.memberBuyPercentage = getNumberData(
                          1,
                          $event,
                          1,
                          0,
                          100
                        )
                      "
                      placeholder="请输入"
                      style="width: 80px"
                      @keyup.native="
                        scope.row.memberBuyPercentage = oninput2(
                          scope.row.memberBuyPercentage,
                          scope.$index,
                          2
                        )
                      "
                      :disabled="
                        !activityData.status
                          ? false
                          : !scope.row.totalAmount
                          ? true
                          : false
                      "
                    ></el-input>
                    %
                  </template>
                </el-table-column>

                <el-table-column
                  label="剩余库存"
                  width="80"
                  v-if="activityData.isStart"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.prizeType != 9">{{
                      scope.row.remanentAmount
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="160">
                  <template slot-scope="scope">
                    <jd-button
                      :disabled="activityData.isStart"
                      type="blueText"
                      @click="cleanData(scope.row, scope.$index)"
                      >清除</jd-button
                    >
                    <jd-button
                      type="blueText"
                      style="margin-left: 5px"
                      v-if="
                        activityData.isStart &&
                        scope.row.title &&
                        scope.row.title != '谢谢参与'
                      "
                      @click="itemAddNum('prizeSettingList', scope.$index)"
                      >增加奖品数量</jd-button
                    >
                  </template>
                </el-table-column>
              </jd-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              <div style="margin-top: 12px">
                <jd-tip>
                  <div>
                    说明<br />
                    <p>
                      1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
                    </p>
                    <p>
                      2、中奖率/入会且已购中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
                    </p>
                    <p>
                      3、为避免客诉，奖品中奖概率不建议设置为0；若奖品中奖概率一定要设置为0，一切后果由商家承担；
                    </p>
                    <p>
                      4、进行中的活动修改中奖概率有一定客诉风险，不建议频繁修改。
                    </p>
                  </div>
                </jd-tip>
              </div>
            </el-form-item>
          </div>
          <activityPageSettings
            isShowShopName
            :cusTemplateJSON.sync="cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            themeTitle="主题"
            :templateId="templateId"
            @selectTemplate="selectTemplate"
            :widthNumber="750"
            :heightNumber="2520"
            previewKey="imageUrl"
            templatekey="secondImageUrl"
            :isShowDesignNumber="false"
            :descLimit="20"
            downloadTemplateUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/集卡有礼.psd"
            designSpecificationsUrl="https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/cellectCard-design.png"
            v-model="customerPaperwork"
          >
            <template #otherSet>
              <el-form-item label="自定义抽卡按钮背景:">
                <div class="flexc-cen-x">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="beforeUploadBtn"
                    :on-success="handleUploadBtn"
                  >
                    <div class="btn-bg" v-if="customerPaperwork.drawCardUrl">
                      <img
                        :src="customerPaperwork.drawCardUrl"
                        style="width: 100%; height: auto"
                      />
                    </div>
                    <jd-button v-else type="blue">自定义上传</jd-button>
                  </el-upload>
                  <jd-button
                    class="ml10"
                    type="blueText"
                    @click="customerPaperwork.drawCardUrl = ''"
                    >重置</jd-button
                  >
                  <jd-button
                    @click="downloadTemplate"
                    type="blueText"
                    style="margin-left: 10px !important"
                    >下载模板</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="抽卡按钮文字颜色:">
                <div class="flexc-cen-x">
                  <el-color-picker
                    v-model="customerPaperwork.drawCardRgb"
                    class="colorPicker"
                  >
                  </el-color-picker>
                  <jd-button
                    class="ml10"
                    type="blueText"
                    @click="customerPaperwork.drawCardRgb = currrentCardRgb"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="自定义抽奖按钮背景:">
                <div class="flexc-cen-x">
                  <el-upload
                    class="upload"
                    action="/jd-hd-web/image/upload"
                    :show-file-list="false"
                    :before-upload="beforeUploadBtn2"
                    :on-success="handleUploadBtn2"
                  >
                    <div class="btn-bg" v-if="customerPaperwork.drawPrizeUrl">
                      <img
                        :src="customerPaperwork.drawPrizeUrl"
                        style="width: 100%; height: auto"
                      />
                    </div>
                    <jd-button v-else type="blue">自定义上传</jd-button>
                  </el-upload>
                  <jd-button
                    class="ml10"
                    type="blueText"
                    @click="customerPaperwork.drawPrizeUrl = ''"
                    >重置</jd-button
                  >
                  <jd-button
                    style="margin-left: 10px !important"
                    @click="downloadTemplate"
                    type="blueText"
                    >下载模板</jd-button
                  >
                  <!-- <jd-button
                    style="margin-left: 10px !important"
                    type="blueText"
                    @click="checkDesign(2)"
                    >查看设计规范</jd-button
                  > -->
                </div>
              </el-form-item>
              <el-form-item label="抽奖按钮文字颜色:">
                <div class="flexc-cen-x">
                  <el-color-picker
                    v-model="customerPaperwork.drawPrizeRgb"
                    class="colorPicker"
                  >
                  </el-color-picker>
                  <jd-button
                    class="ml10"
                    type="blueText"
                    @click="customerPaperwork.drawPrizeRgb = currrentPrizeRgb"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
              <el-form-item label="选中卡片描边颜色:">
                <div class="flexc-cen-x">
                  <el-color-picker
                    v-model="customerPaperwork.cardBorderColor"
                    class="colorPicker"
                  >
                  </el-color-picker>
                  <jd-button
                    class="ml10"
                    type="blueText"
                    @click="customerPaperwork.cardBorderColor = cardBorderColor"
                    >重置</jd-button
                  >
                </div>
              </el-form-item>
            </template>
          </activityPageSettings>
          <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleForm.ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleForm.ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleForm.ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleForm.ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item>
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
            :limitNum="limitNum"
          ></exposureList
          >
          <sharFrom :sharePic="sharePic" v-model="ruleForm"></sharFrom>
          <activityRules
            :needIsForceRemind="false"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      :endTime="activityEndTime"
      activityType="8"
      v-if="isSelectProduct"
      :echoDate="echoDate"
      :actId="valueRow"
      :num="1"
      :JingdouCount="JingdouCount"
      @choose-shop="getTheData"
      :actType="62"
      :actEndTime="ruleForm.endTime"
      :notBaidu="activityData.id == 8 ? true : false"
    >
    </selectProduct>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 添加任务 -->
    <jd-dialog
      :title="`${isTaskEdit ? '修改任务' : '添加任务'}`"
      :visible.sync="taskDialog"
      :width="taskForm.type ==17 ? '800px' : '600px'"
      @close="taskClose"
      v-if="taskDialog"
    >
      <el-form
        :model="taskForm"
        style="position: relative"
        class="new-input-box"
        label-width="auto"
      >
        <div
          v-if="taskIsLook"
          style="
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            z-index: 1;
          "
        ></div>
        <el-form-item label="任务类型:" required>
          <el-select
            v-model="taskForm.type"
            style="width: 350px"
            @change="taskTypeChange"
          >
            <el-option
              v-for="item in taskTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="task-tip-wrap">
          <jd-tip class="task-tip" v-if="taskForm.type == 1">
            <div>任务说明：用户每日都可进入活动页签到，获得抽卡机会。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 2">
            <div>任务说明：用户每日都可进入活动页浏览店铺，获得抽卡机会。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 13">
            <div>任务说明：</div>
            <div>1.用户浏览商品可以获得抽卡机会；</div>
            <div>2.商品是以单个SKU为单位，浏览同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 4">
            <div>任务说明：</div>
            <div>1.用户成功加购商品可以获得抽卡机会；</div>
            <div>2.商品是以单个SKU为单位，加购同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 9">
            <div>任务说明：</div>
            <div>1.用户成功分享商品可以获得抽卡机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 10">
            <div>任务说明：</div>
            <div>1.用户成功分享店铺可以获得抽卡机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 11">
            <div>任务说明：</div>
            <div>1.用户成功分享活动可以获得抽卡机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 8">
            <div>任务说明：</div>
            <div>1.用户成功邀请好友可以获得抽卡机会；</div>
            <div>
              2.被邀请人只有点击助力链接才算一次有效助力，且活动期间每人只有1次助力机会；
            </div>
            <div>3.用户在活动期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 5">
            <div>任务说明：</div>
            <div>1.此任务可以放链接，必须遵从以下规则：</div>
            <div>（1） 链接须包含 .isvjcloud.com，.isvjd.com或.jd.com</div>
            <div>（2） 只能以http://,https://开头</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 12">
            <div>任务说明：</div>
            <div>1.用户成功预约商品可以获得抽奖机会；</div>
            <div>2.商品是以单个SKU为单位，预约同一个商品多次按1次计算；</div>
            <div>3.用户在活动时间期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 16">
            <div>任务说明：用户消耗一定积分可兑换抽卡机会次数。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 17">
            <div>
              <div>任务说明：</div>
              <div>
                1、因官方接口限制，POP统计订单实付金额，自营统计订单金额（是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。）；
              </div>
              <div>2、指定购买商品：订单包含任意指定商品均会被统计；</div>
              <div>
                3、选择订单状态为“已完成”，则仅限交易完成的订单可获得抽卡机会，如：活动已结束，交易未完成，则不赠送次数；
              </div>
              <div>
                4、如买家通过消费任务获得次数后进行退款的情况，已赠送的次数不会撤回；
              </div>
              <div style="color: #fe4d45">
                5、如设置【购物任务】条件，则活动对象设置必须为会员身份，接口限制非会员无法统计交易数据。
              </div>
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 18">
            <div>任务说明：用户邀请好友成功入会，可获取抽卡机会；</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 23">
            <div>任务说明：此任务可以放搜索关键词，用户进入活动点击去搜索自动带【关键词】跳转至APP查询页查询；</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 7">
            <div>任务说明：用户可参与入会任务，增加抽卡机会。</div>
          </jd-tip>
        </div>
        <el-form-item label="任务有效期:" required>
          <div class="task-wrap">
            <div class="task-wrap-radio">
              <el-radio v-model="taskForm.taskTime" :label="1"
                >长期有效</el-radio
              >
              <el-radio v-model="taskForm.taskTime" :label="2"
                >指定日期</el-radio
              >
            </div>
            <div class="my_select_time" v-if="taskForm.taskTime == 2">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="taskForm.startTime"
                type="date"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="taskForm.endTime"
                type="date"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 120px; font-size: 12px"
                class="time2"
                :clearable="false"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart"
                @click="clearTaskTime()"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="邀请人数上限:"
          required
          v-if="taskForm.type == 8"
        >
          <span>
            <el-input
              v-model.number="taskForm.inviteLimit"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.inviteLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
          </span>
          人
        </el-form-item>
        <el-form-item
          label="跳转链接:"
          required
          v-if="taskForm.type == 5"
        >
          <el-input v-model="taskForm.jumpUrl"></el-input>
          <div>
            <span class="tip-red">注：跳转的链接必须为京东链接</span>
          </div>
        </el-form-item>
        <template v-if="taskForm.type == 17">
          <el-form-item label="奖励规则：" required>
            <el-select
              v-model="taskForm.giveType"
              style="width: 200px"
              @change="giveTypeChange"
            >
              <el-option
                v-for="item in rewardRulesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-tooltip
              class="item"
              effect="light"
              placement="right"
              style="margin-left: 8px"
            >
              <div slot="content">
                1、按固定次数赠送抽奖机会：例如设置【满10元及以上赠送1次机会】，若用户下单100元，则也只赠送1次机会；
                <br />
                2、按倍数赠送抽奖机会：例如设置【每满100元及以上赠送1次机会】，若按单笔，则用户第一次下单90元，则未达到赠送条件，第二次下单110元，则赠送1次机会；
                <br />
                若按累计，则用户第一次下单90元，未达到赠送条件；第二次下单110元，两笔订单合起来为200元，则赠送2次抽奖机会
                <br />
                3、按阶梯赠送抽奖机会：例如设置多阶梯【满10元及以上赠送1次机会，满30元及以上赠送3次机会】，若按单笔，用户第一次下单10元，则赠送1次机会，第二次下单20元，满足“满10元未达到30元”，则赠送1次
                <br />
                若按累计，用户下单10元，则本次赠送1次机会，该用户再次下单20元，此时满足第二个阶梯30元，但是由于已经赠送了1次机会，所以再次赠送2次机会。达到满30元赠送3次机会的设置。
                <br />
              </div>
              <div
                style="
                  display: inline-flex;
                  cursor: pointer;
                  align-items: center;
                "
              >
                奖励规则说明<i
                  class="el-icon-question"
                  style="color: #ccc; margin-left: 2px"
                ></i>
              </div>
            </el-tooltip>
            <div class="rule_box">
              <el-form-item label="下单店铺:" required>
                <orderShopCom
                  :venderIds.sync="taskForm.venderIds"
                  :multiShopGoods.sync="multiShopGoods"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                />
              </el-form-item>
              <el-form-item label="下单时间:" required>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderStartTime"
                    :picker-options="taskstartpickerOptionsValue"
                    type="datetime"
                    placeholder="开始日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 148px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderEndTime"
                    :picker-options="taskpickerOptionsValueEnd"
                    type="datetime"
                    placeholder="结束日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    default-time="23:59:59"
                    style="width: 152px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <i
                    class="el-icon-circle-close date_icon1"
                    v-if="!activityData.isStart"
                    @click="clearOrderTime()"
                  ></i>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                    alt=""
                    class="date_icon2"
                  />
                </div>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="最长时间跨度不超过90天"
                  placement="bottom"
                  style="margin-left: 8px"
                >
                  <div
                    style="width: 35px; display: inline-flex; cursor: pointer"
                  >
                    <i class="el-icon-question" style="color: #ccc"></i>
                  </div>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="taskForm.orderPaymentType"
                >
                  <el-radio :label="1">
                    <span>订单金额（后台价）</span>
                    <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="0" v-if="!isVenderType">
                    <span>用户应付金额</span>
                    <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="2" v-if="!isVenderType">
                    <span>用户实付金额</span>
                    <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="商品要求："
                required
                class="skuType-label"
              >
                <!-- <el-radio v-model="taskForm.skuType" :label="0"
                  >全部商品</el-radio
                >
                <el-radio v-model="taskForm.skuType" :label="1"
                  >指定商品</el-radio
                >
                <div style="display: inline-block">
                  <jd-button
                    type="blue"
                    @click="showGoods(100)"
                    :disabled="taskForm.skuType != 1"
                    >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
                  >
                </div> -->
                <productReqCom
                  :filterType.sync="taskForm.skuType"
                  :venderIds.sync="taskForm.venderIds"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                  :multiShopGoods.sync="multiShopGoods"
                  :isShowExclude="false"
                  :limitNum="goodsLimit"
                  addGoodText="选择商品"
                />
              </el-form-item>
              <!-- 指定商品规则：仅商品要求为"指定商品"时展示，0=整单计算 1=仅统计指定商品金额和件数 -->
              <el-form-item label="指定商品规则:" v-if="taskForm.orderPaymentType==1&&taskForm.skuType == 1">
                <el-select style="width: 280px;" v-model="taskForm.statsSkuType" placeholder="">
                  <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                  <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="订单金额："
                v-if="taskForm.giveType == 0"
                required
              >
                大于等于<el-input
                  style="width: 120px; margin: 0 8px"
                  v-model="taskForm.amtLimit"
                  @input="validateInput"
                />元
              </el-form-item>
              <el-form-item
                label="商品件数："
                v-if="taskForm.giveType == 0"
                style="margin-left: 12px"
              >
                大于等于<el-input
                  style="width: 120px; margin: 0 8px"
                  v-model="taskForm.itemTotalLimit"
                  @input="validateInputNew"
                />件
              </el-form-item>
              <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                <el-radio-group
                  v-model="taskForm.mergeOrder"
                >
                  <el-radio :label="false">否</el-radio>
                  <el-radio :label="true">是</el-radio>
                </el-radio-group>
                <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
              </el-form-item>
              <el-form-item label="订单状态:" required>
                <el-radio v-model="taskForm.orderType" :label="0"
                  >已付款</el-radio
                >
                <el-radio v-model="taskForm.orderType" :label="1"
                  >已完成</el-radio
                >
              </el-form-item>
              <el-form-item label="统计方式:"  required>
                <el-radio
                  v-model="taskForm.orderCountType"
                  @change="taskForm.countType = 1"
                  :label="1"
                  @input="taskForm.condition2 = ''"
                  >累计订单</el-radio
                >
                <el-radio
                  v-model="taskForm.orderCountType"
                  @change="taskForm.countType = 1"
                  :label="0"
                  @input="taskForm.condition2 = ''"
                  >单笔订单</el-radio
                >
              </el-form-item>
              <el-form-item
                label="统计类型:"
                v-if="taskForm.giveType == 1 || taskForm.giveType == 2"
                required
              >
                <el-radio
                  @change="countTypeChange"
                  v-model="taskForm.countType"
                  :label="1"
                  >按订单金额</el-radio
                >
                <el-radio
                  @change="countTypeChange"
                  v-model="taskForm.countType"
                  :label="2"
                  >按商品件数</el-radio
                >
                <el-radio
                  @change="countTypeChange"
                  v-if="taskForm.orderCountType == 1"
                  v-model="taskForm.countType"
                  :label="3"
                  >按订单笔数</el-radio
                >
              </el-form-item>
              <el-form-item label="任务条件:" required>
                <span
                  v-if="taskForm.orderCountType == 0 && taskForm.giveType == 0"
                >
                  每1个订单赠送1次抽卡机会
                </span>
                <span
                  v-else-if="
                    taskForm.orderCountType == 1 && taskForm.giveType == 0
                  "
                >
                  完成任务赠送1次抽卡机会
                </span>
                <span v-else-if="taskForm.giveType == 1">
                  <div
                    v-for="(item, index) in taskLevelList"
                    :key="index"
                    style="margin-bottom: 6px"
                  >
                    <span v-if="taskForm.countType == 1"
                      >每满<el-input
                        placeholder="请输入金额"
                        v-model="item.limit"
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInput(e);
                          }
                        "
                      />元</span
                    >
                    <span v-if="taskForm.countType == 2"
                      >每满<el-input
                        placeholder="请输入件数"
                        v-model="item.limit"
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />件</span
                    >
                    <span v-if="taskForm.countType == 3"
                      >每满<el-input
                        placeholder="请输入笔数"
                        v-model="item.limit"
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />笔</span
                    >
                    ，赠送
                    <el-input
                      v-model.number="item.giveNum"
                      placeholder="请输入次数"
                      style="width: 95px"
                      @input="
                        item.giveNum = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input>
                    次抽卡机会
                  </div>
                </span>
                <span v-else-if="taskForm.giveType == 2">
                  <div
                    v-for="(item, index) in taskLevelList"
                    :key="index"
                    style="margin-bottom: 6px"
                  >
                    <span v-if="taskForm.countType == 1"
                      >每满<el-input
                        placeholder="请输入金额"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInput(e);
                          }
                        "
                      />元</span
                    >
                    <span v-if="taskForm.countType == 2"
                      >每满<el-input
                        placeholder="请输入件数"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />件</span
                    >
                    <span v-if="taskForm.countType == 3"
                      >每满<el-input
                        placeholder="请输入笔数"
                        v-model="item.limit"
                        @change="
                          (e) => {
                            item.limit = NumChange(e, 'limit', index);
                          }
                        "
                        style="width: 95px; margin: 0 8px"
                        @input="
                          (e) => {
                            item.limit = inputValidateInputNew(e);
                          }
                        "
                      />笔</span
                    >
                    ，赠送
                    <el-input
                      v-model.number="item.giveNum"
                      @change="
                        (e) => {
                          item.giveNum = NumChange(e, 'giveNum', index);
                        }
                      "
                      placeholder="请输入次数"
                      style="width: 95px"
                      @input="
                        item.giveNum = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input>
                    次抽卡机会
                    <span
                      v-if="index >= 2"
                      @click="delTaskLevel(index)"
                      style="cursor: pointer"
                      ><i class="el-icon-error"></i
                    ></span>
                  </div>
                  <jd-button
                    :disabled="taskLevelList.length >= 5"
                    style="margin-right: 8px"
                    @click="addTaskLevel"
                    >添加阶梯({{ taskLevelList.length }}/5)</jd-button
                  >
                </span>
              </el-form-item>
              <el-form-item label="任务次数:" required>
                <span
                  v-if="taskForm.orderCountType == 0 && taskForm.giveType == 0"
                >
                  活动期间最多完成
                  <el-input
                    v-model.number="taskForm.condition2"
                    placeholder="请输入"
                    style="width: 80px"
                    @input="
                      taskForm.condition2 = getNumberData(1, $event, 0, 1, 999)
                    "
                  ></el-input>
                  次
                </span>
                <span
                  v-else-if="taskForm.giveType == 1 || taskForm.giveType == 2"
                >
                  <el-radio v-model="taskForm.taskDoType" :label="0"
                    >不限制次数</el-radio
                  >
                  <el-radio v-model="taskForm.taskDoType" :label="1"
                    >限制次数</el-radio
                  >
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="限制该任务可活动抽奖次数上限"
                    placement="bottom"
                    style="margin-left: 8px"
                  >
                    <div
                      style="width: 35px; display: inline-flex; cursor: pointer"
                    >
                      <i class="el-icon-question" style="color: #ccc"></i>
                    </div>
                  </el-tooltip>
                  <div v-if="taskForm.taskDoType == 1">
                    活动期间最多获得<el-input
                      v-model.number="taskForm.condition2"
                      placeholder="请输入"
                      style="width: 80px"
                      @input="
                        taskForm.condition = getNumberData(1, $event, 0, 1, 999)
                      "
                    ></el-input
                    >次抽卡机会
                  </div>
                </span>
                <span v-else>{{ taskForm.count }}</span>
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="搜索关键词:" v-if="taskForm.type == 23" label-width="110px" required>
          <el-input 
            style="width: 320px;" 
            v-model="taskForm.searchKeyword" 
            placeholder="请输入搜索关键词，例【橙汁】"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="任务条件:"
          v-if="taskForm.type != 17"
          required
        >
          <span v-if="taskForm.type == 13">
            成功浏览
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次抽卡机会
          </span>
          <span v-else-if="taskForm.type == 4">
            成功加购
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次抽卡机会
          </span>
          <span v-else-if="taskForm.type == 9">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次商品，赠送1次抽卡机会
          </span>
          <span v-else-if="taskForm.type == 10">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次店铺，赠送1次抽卡机会
          </span>
          <span v-else-if="taskForm.type == 11">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次活动，赠送1次抽卡机会
          </span>
          <span v-else-if="taskForm.type == 12">
            每成功预约
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次抽卡机会
          </span>
          <span v-else-if="taskForm.type == 16">
            每
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            积分可兑换1次机会
          </span>
          <span v-else-if="taskForm.type == 18">
            每成功邀请
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            个好友入会，赠送1次抽卡机会
          </span>
          <div v-else-if="taskForm.type == 5" class="flexc-cen-x">
            <span>每成功浏览当前链接</span>
            <el-input
              class="ml8"
              style="width: 100px"
              v-model="taskForm.viewTime"
              @input="taskForm.viewTime = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8 mr8">秒，赠送</span>
            <el-input
              style="width: 100px"
              v-model="taskForm.giveLimit"
              @input="taskForm.giveLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8">次抽卡机会</span>
          </div>
          <div v-else-if="taskForm.type == 7" class="flexc-cen-x">
            <span class="mr8">成功加入会员获取</span>
            <el-input
              style="width: 100px"
              placeholder="请输入"
              v-model="taskForm.giveLimit"
              @input="taskForm.giveLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8">次抽卡机会</span>
          </div>
          <span v-else>{{ taskForm.condition }}</span>
        </el-form-item>
        <el-form-item
          label="浏览商品:"
          required
          v-if="taskForm.type == 13"
        >
          <jd-button type="blue" @click="showGoods(100)"
            >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="加购商品:"
          required
          v-if="taskForm.type == 4"
        >
          <jd-button type="blue" @click="showGoods(100)"
            >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="分享商品:"
          required
          v-if="taskForm.type == 9"
        >
          <jd-button type="blue" @click="showGoods(1)"
            >选择商品（{{ taskForm.skuIds.length }}/1）</jd-button
          >
        </el-form-item>
        <el-form-item
          label="预约商品:"
          required
          v-if="taskForm.type == 12"
        >
          <div class="book-good-wrap">
            <jd-button type="blue" @click="showGoods(100)"
              >选择商品（{{ taskForm.skuIds.length }}/100）</jd-button
            >
            <span class="tip-red" style="margin-left: 10px"
              >注意：请添加预约商品，非预约商品无法完成任务</span
            >
          </div>
        </el-form-item>
        <el-form-item
          label="任务次数:"
          v-if="taskForm.type != 17"
          required
        >
          <span v-if="taskForm.type == 12">
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 8">
            {{
              `活动期间内最多完成${
                taskForm.inviteLimit ? taskForm.inviteLimit : 0
              }次`
            }}
          </span>
          <span v-else-if="taskForm.type == 16">
            <el-select v-model="taskForm.activityType" placeholder="请选择">
              <el-option label="活动期间" :value="2"></el-option>
              <el-option label="每日" :value="1"></el-option>
            </el-select>
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 18">
            活动期间最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 11 || taskForm.type == 4">
            活动期间最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 80px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else>{{ taskForm.count }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <jd-button style="margin-right: 8px" @click="taskClose">取消</jd-button>
        <jd-button v-if="!taskIsLook" type="blue" @click="sureTask"
          >确定</jd-button
        >
      </div>
    </jd-dialog>
    <!-- 选择商品弹窗 -->
    <select-goods
      v-if="goodsState"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="goodsLimit"
      :isShow="goodsState"
      :moduleType="true"
      :selectGoods="selectGoodsSkuList"
      @close="selectGoodsChange"
    ></select-goods>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 每日发放限额弹窗 -->
    <setLimitDialog
      :visible.sync="showLimitDialog"
      :init-data="limitData"
      :backgroundOpacity="backgroundOpacity"
      @confirm="handleLimitConfirm"
    />
    <!-- 选择统一奖品弹窗 -->
    <selectProduct
      ref="unifiedPrizeRef"
      v-if="showUnifiedPrize"
      :echoDate="currentUnifiedPrize"
      :num="1"
      :actId="valueRow"
      :JingdouCount="unifiedJingdouCount"
      :typeDefault="typeDefault"
      :actType="62"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getUnifiedData"
    >
    </selectProduct>
    <!-- 选择阶梯奖品弹窗 -->
    <selectProduct
      ref="stepPrizeRef"
      v-if="showStepPrize"
      :echoDate="currentStepPrize"
      :num="1"
      :actId="valueRow"
      :JingdouCount="stepJingdouCount"
      :typeDefault="typeDefault"
      :actType="62"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getStepData"
    >
    </selectProduct>
    <el-dialog
      title="设计规范"
      :visible.sync="isShowDesignSpecifications"
      width="800px"
    >
      <img
        style="width: 760px; object-fit: cover"
        :src="designSpecificationsUrl"
      />
    </el-dialog>
  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor2";
import selectProduct from "./select_product_componentization.vue";
import {
  saveCollectCard,
  getCollectCardDetail,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import draggable from "vuedraggable";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import addPrizeNum from "./components/add-prize-num.vue";
import setLimitDialog from "@/views/interactiveMarketing/activity/components/_components/setLimitDialog.vue";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import orderShopCom from "./components/multipleStoreSetting/orderShopCom.vue";
import productReqCom from "./components/multipleStoreSetting/productReqCom.vue";
import { useValidateMultiShopGoods } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
export default {
  components: {
    SelectGoods,
    selectProduct,
    draggable,
    addPrizeNum,
    setLimitDialog,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    dailyLimitConfig,
    orderShopCom,
    productReqCom,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    permissions:{
      handler(nVal, oVal) {
        if (nVal.indexOf("hide:interactive:product:offline") != "-1") {
         this.isPremissionShow = false;
        }
      },
      immediate: true,
    },
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(5);
    },
    selectedIndex(newVal, oldVal) {
      if (newVal != -1) {
        this.ruleForm.ruleDTO.isKeyCardThanks = 1;
      } else {
        this.ruleForm.ruleDTO.keyCardStartTime = "";
        this.ruleForm.ruleDTO.keyCardEndTime = "";
        this.ruleForm.ruleDTO.isKeyCardThanks = 0;
      }
    },
    "ruleForm.ruleDTO.collectCardType": {
      handler(newVal, oldVal) {
        if (newVal == 0) {
          this.ruleForm.ruleDTO.shardNumber = 2;
          this.ruleForm.ruleDTO.isRepeatRule = false;
          this.ruleForm.ruleDTO.repeatNumbe = "";
          this.stepList.forEach((item) => {
            item.statisticsRule = 0;
            item.collectCardNum = "";
          });
          this.ruleForm.ruleDTO.exchangeRule.statisticsRule = 0
        }
      },
      deep: true,
    },
    cardDrawGiveType(newVal, oldVal) {
      if (newVal == 0) {
        this.ruleForm.ruleDTO.everyDayGiveTimes = "";
      } else {
        this.ruleForm.ruleDTO.firstGiveTimes = "";
      }
    },
    "ruleForm.ruleDTO.prizeType": {
      handler(newVal, oldVal) {
        if (newVal == 1) {
          this.ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber = "";
          this.ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber = "";
          this.ruleForm.ruleDTO.lotteryRule.oneDayMaxRewardNumber = "";
          this.ruleForm.ruleDTO.lotteryRule.totalMaxRewardNumber = "";
        } else {
          this.ruleForm.ruleDTO.exchangeRule.exchangeType = 0;
          this.ruleForm.ruleDTO.exchangeRule.exchangeNumber = "";
        }
      },
      deep: true,
    },
    "ruleForm.ruleDTO.exchangeRule.prizeRule": {
      handler(newVal, oldVal) {
        if (newVal == 1) {
          this.ruleForm.ruleDTO.exchangeRule.statisticsRule = 0;
        } else {
          this.stepList = [
            {
              taskIndex: 1,
              statisticsRule: 0,
              collectSetNum: "",
              collectCardNum: "",
              stepPrizeDTO: [
                {
                  assetsId: null,
                  title: "",
                  price: null,
                  logo: "",
                  totalAmount: "",
                  prizeType: null,
                  predictSendTime: "",
                  isFollowActivityEndTime: 1,
                  addressFillEndTime: "",
                },
              ],
            },
            {
              taskIndex: 2,
              statisticsRule: 0,
              collectSetNum: "",
              collectCardNum: "",
              stepPrizeDTO: [
                {
                  assetsId: null,
                  title: "",
                  price: null,
                  logo: "",
                  totalAmount: "",
                  prizeType: null,
                  predictSendTime: "",
                  isFollowActivityEndTime: 1,
                  addressFillEndTime: "",
                },
              ],
            },
          ];
        }
      },
      deep: true,
    },
    "ruleForm.ruleDTO.cardDrawType": {
      handler(newVal) {
        if (newVal == 1) {
          this.taskDataList = [];
        }
      },
      deep: true,
    },
    "ruleForm.ruleDTO.isRepeatRule": {
      handler(newVal) {
        if (!newVal) {
          this.ruleForm.ruleDTO.repeatNumber = "";
        }
      },
      deep: true,
    },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.taskForm.orderPaymentType = 1
      } 
    },
  },
  data() {
    return {
      isKeyActivity: 0, // 是否重点活动
      placementPosition: [], // 活动投放位置
      isPremissionShow: true,
      loading: false,
      templateObj: {},
      isStepStr: false,
      currentStrStepIndex: -1,
      cardDrawGiveType: 0,
      currrentCardRgb: "",
      currrentPrizeRgb: "",
      cardBorderColor: "",
      downloadTemplateUrl: "",
      isShowDesignSpecifications: false,
      designSpecificationsUrl: "",
      customerPaperwork: {
        title: "集卡换好礼",
        desc: "参与抽卡，集成得好礼",
        titleColor: "#242424",
        drawCardUrl: "", //自定义抽卡按钮背景
        drawCardRgb: "#40241B", //自定义抽卡按钮文字颜色
        drawPrizeUrl: "", //自定义抽奖按钮背景
        drawPrizeRgb: "#FFFFFF", //抽奖按钮文字颜色
        cardBorderColor: "#DEBE94", //选中卡片描边颜色
      },
      showStepPrize: false, //选择阶梯奖品弹窗
      currentStepPrize: {}, //当前选择的阶梯奖品
      currentStepIndex: 0,
      currentStepPrizeIndex: 0,
      stepJingdouCount: {
        prizeCount: 0,
      }, //阶梯奖品的京豆数量
      stepList: [
        {
          taskIndex: 1,
          statisticsRule: 0,
          collectSetNum: "",
          collectCardNum: "",
          stepPrizeDTO: [
            {
              assetsId: null,
              title: "",
              price: null,
              logo: "",
              totalAmount: "",
              prizeType: null,
              predictSendTime: "",
              isFollowActivityEndTime: 1,
              addressFillEndTime: "",
            },
          ],
        },
        {
          taskIndex: 2,
          statisticsRule: 0,
          collectSetNum: "",
          collectCardNum: "",
          stepPrizeDTO: [
            {
              assetsId: null,
              title: "",
              price: null,
              logo: "",
              totalAmount: "",
              prizeType: null,
              predictSendTime: "",
              isFollowActivityEndTime: 1,
              addressFillEndTime: "",
            },
          ],
        },
      ], //阶梯奖品
      currentIndex: 0,
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      unifiedJingdouCount: {
        prizeCount: 0,
      },
      showUnifiedPrize: false,
      currentUnifiedPrize: {},
      // 统一奖品
      bigTurntableDrawPrizeDTOS: [
        {
          index: 0,
          assetsId: null,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          assetsId: null,
          predictSendTime: "",
          isFollowActivityEndTime: 1,
          addressFillEndTime: "",
        },
      ],
      selectedIndex: -1,
      cusTemplateJSON: "",

      taskIsLook: false,
      actEndTime: "",
      actMember: "1",
      peopleSelected: [],
      isSelectProduct: false,
      mainImagelist: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      selectGoodsArr: [],
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      echoDate: {},
      // 关键卡开启时间
      cardStartLimit: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() <
                new Date(this.ruleForm.startTime).valueOf() - 8.64e7
            );
          } else if (this.ruleForm.ruleDTO.keyCardEndTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.ruleForm.ruleDTO.keyCardEndTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      cardEndLimit: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else if (this.ruleForm.ruleDTO.keyCardStartTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() <
                new Date(this.ruleForm.ruleDTO.keyCardStartTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      taskstartpickerOptionsValue: {
        disabledDate: (time) => {
          const endTime = this.taskForm.orderEndTime
            ? new Date(this.taskForm.orderEndTime).getTime() -
              1 * 24 * 60 * 60 * 1000
            : null;
          const maxStartTime = endTime
            ? endTime - 90 * 24 * 60 * 60 * 1000
            : null;
          return (
            (endTime && time.getTime() > endTime) ||
            (maxStartTime && time.getTime() < maxStartTime)
          );
        },
      },
      taskpickerOptionsValueEnd: {
        disabledDate: (time) => {
          const startTime = this.taskForm.orderStartTime
            ? new Date(this.taskForm.orderStartTime).getTime() +
              1 * 24 * 60 * 60 * 1000
            : null;
          const maxEndTime = startTime
            ? startTime + 89 * 24 * 60 * 60 * 1000
            : null;
          return (
            (startTime && time.getTime() < startTime) ||
            (maxEndTime && time.getTime() > maxEndTime)
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        ruleDTO: {
          plusObject: 0,
          openCardEndTime: "",
          openCardStartTime: "",
          goShopSetting: 0,
          goShopAppId: "",
          goShopUrl: "",
          customerPaperwork: "",
          cusTemplateJSON: "",
          cardDrawType: 0,
          consumePoint: "",
          firstGiveTimes: "",
          everyDayGiveTimes: "",
          collectCardType: 0,
          keyCardStartTime: "",
          keyCardEndTime: "",
          shardNumber: 2,
          isRepeatRule: false,
          repeatNumber: "",
          isKeyCardThanks: 0,
          prizeType: 0,
          lotteryRule: {
            oneDayMaxDrawNumber: "",
            totalMaxDrawNumber: "",
            oneDayMaxRewardNumber: "",
            totalMaxRewardNumber: "",
            statisticsRule: 0,
            bigTurntableDrawPrizeDTOS: [],
          },
          exchangeRule: {
            exchangeType: 0,
            exchangeNumber: "",
            prizeRule: 0,
            statisticsRule: 0,
            stepList: [],
          },
          taskList: [],
          firstOpenCardTimeType: 0, // 首次入会时间类型
          openCardBeforeDay: "", // 参与活动前N天
          openCardFollow: 0, // 开卡入会后方可参与活动
        },

        isExposureItem: false,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        pointActivityPrizeDTOList: [],
        isValidBlackList: 0,
      },
      taskDialog: false,
      taskTypeOptions: [
        {
          label: "每日签到",
          value: 1,
          taskCondition: "成功签到，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "浏览店铺",
          value: 2,
          taskCondition: "成功浏店铺，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "浏览商品",
          value: 13,
          taskCondition: "成功浏览XX件商品，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "加购商品",
          value: 4,
          taskCondition: "成功加购XX件商品，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "分享商品",
          value: 9,
          taskCondition: "成功分享XX件商品，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "分享店铺",
          value: 10,
          taskCondition: "成功分享XX次店铺，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "分享活动",
          value: 11,
          taskCondition: "成功分享XX次活动，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "好友助力",
          value: 8,
          taskCondition: "每邀请1位好友，赠送1次抽奖机会",
          taskCount: "活动期间最多最多完成XX次",
        },
        {
          label: "浏览会场",
          value: 5,
          taskCondition: "成功浏览会场，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成1次",
        },
        {
          label: "预约商品",
          value: 12,
          taskCondition: "每成功预约XX件商品，赠送1次抽卡机会，最多完成YY次",
          taskCount: "活动期间最多完成YY次",
        },
        {
          label: "积分兑换",
          value: 16,
          taskCondition: "每xx积分可兑换1次机会",
          taskCount: "活动期间最多完成YY次",
        },
        {
          label: "购买商品",
          value: 17,
          taskCondition: "完成任务赠送1次抽卡机会",
          taskCount: "活动期间最多完成1次",
        },
        {
          label: "邀请好友入会",
          value: 18,
          taskCondition: "成功邀请XX个好友入会，赠送1次抽卡机会",
          taskCount: "活动期间最多完成YY次",
        },
        {
          label: "搜索关键词",
          value: 23,
          taskCondition: "成功搜索关键词，赠送1次抽卡机会",
          taskCount: "活动期间每日最多完成一次",
        },
        {
          label: "加入会员",
          value: 7,
          taskCondition: "成功加入会员",
          taskCount: "活动期间最多完成1次",
        }
      ],
      conditionValue: [13, 4, 9, 10, 11, 12, 16, 17, 18],
      goodsTypeList: [13, 4, 9, 12],
      goodsLimitList: [13, 4, 12],
      rewardRulesOptions: [
        {
          value: 0,
          label: "按固定次数赠送抽卡机会",
        },
        {
          value: 1,
          label: "按倍数赠送抽卡机会",
        },
        {
          value: 2,
          label: "按阶梯赠送抽卡机会",
        },
      ],
      taskLevelList: [],
      taskForm: {
        // 1.29迭代参数
        giveType: 0,
        countType: 1,
        taskDoType: 0,

        type: 1,
        taskTime: 1,
        condition: null,
        condition2: null,
        count: null,
        endTime: null,
        startTime: null,
        skuIds: [],
        inviteLimit: null,
        jumpUrl: null,
        selectGoodsSkuList: [],
        venderIds: [],
        sellerSkuList: [],
        orderPaymentType: 1,
        mergeOrder: false,
      },
      multiShopGoods: [],
      isTaskEdit: false,
      taskRow: {},
      taskDataList: [],
      sharePic: "",
      bigTurntableDrawS: [],
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit: null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
      ],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      itemArr: [],
      goodsState: false,
      goodsLimit: 100,
      selectGoodsSkuList: [],
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: "",
      toAddIndex: 0,
      showLimitDialog: false, // 每日发放限额弹窗
      limitData: {}, // 初始数据
      selectedTaskTypes: [], // 选中的任务类型列表
      taskPrizeConfigs: {}, // 格式: { 1: [...], 2: [...] }
      collectCardList: [
        {
          id: null,
          activityId: "",
          title: "",
          pictureUrl:
            "https://cdn-image.yucrm.cn//hd/images/13315956_b061219dca004bd6af91a4e308dec105.png",
          percentage: "",
          cardLimitNumber: "",
          isKeyCard: false,
          isSelect: -1,
          fileList: [
            {
              url: "https://cdn-image.yucrm.cn//hd/images/13315956_b061219dca004bd6af91a4e308dec105.png",
              name: "集",
            },
          ],
        },
        {
          id: null,
          activityId: "",
          title: "",
          pictureUrl:
            "https://cdn-image.yucrm.cn//hd/images/13315956_979d0ce4da5d424382c5bc1c5ee47028.png",
          percentage: "",
          cardLimitNumber: "",
          isKeyCard: false,
          isSelect: -1,
          fileList: [
            {
              url: "https://cdn-image.yucrm.cn//hd/images/13315956_979d0ce4da5d424382c5bc1c5ee47028.png",
              name: "卡",
            },
          ],
        },
        {
          id: null,
          activityId: "",
          title: "",
          pictureUrl:
            "https://cdn-image.yucrm.cn//hd/images/13315956_79e1d86feee8448eab4d6265201d0b61.png",
          percentage: "",
          cardLimitNumber: "",
          isKeyCard: false,
          isSelect: -1,
          fileList: [
            {
              url: "https://cdn-image.yucrm.cn//hd/images/13315956_79e1d86feee8448eab4d6265201d0b61.png",
              name: "赢",
            },
          ],
        },
        {
          id: null,
          activityId: "",
          title: "",
          pictureUrl:
            "https://cdn-image.yucrm.cn//hd/images/13315956_52a87bb182db4cb9966547b3227d70ad.png",
          percentage: "",
          cardLimitNumber: "",
          isKeyCard: false,
          isSelect: -1,
          fileList: [
            {
              url: "https://cdn-image.yucrm.cn//hd/images/13315956_52a87bb182db4cb9966547b3227d70ad.png",
              name: "好",
            },
          ],
        },
        {
          id: null,
          activityId: "",
          title: "",
          pictureUrl:
            "https://cdn-image.yucrm.cn//hd/images/13315956_f836bc7fa28848b2a038ae7ec3fef588.png",
          percentage: "",
          cardLimitNumber: "",
          isKeyCard: false,
          isSelect: -1,
          fileList: [
            {
              url: "https://cdn-image.yucrm.cn//hd/images/13315956_f836bc7fa28848b2a038ae7ec3fef588.png",
              name: "礼",
            },
          ],
        },
      ],
    };
  },
  computed: {
    //权限判断
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    // 获取任务类型
    getTaskType() {
      return (type) => {
        const obj = this.taskTypeOptions.find((item) => item.value == type);
        return obj.label;
      };
    },
    // 获取任务条件
    getCondition() {
      return (item) => {
        const { type, condition, condition2, orderCountType } = item;
        let str = condition;
        if (type == 13) {
          str = `成功浏览${condition}件商品，赠送1次抽卡机会`;
        } else if (type == 4) {
          str = `成功加购${condition}件商品，赠送1次抽卡机会`;
        } else if (type == 9) {
          str = `成功分享${condition}次商品，赠送1次抽卡机会`;
        } else if (type == 10) {
          str = `成功分享${condition}次店铺，赠送1次抽卡机会`;
        } else if (type == 11) {
          str = `成功分享${condition}次活动，赠送1次抽卡机会`;
        } else if (type == 12) {
          str = `每成功预约${condition}件商品，赠送1次抽卡机会`;
        } else if (type == 16) {
          str = `每${condition}积分可兑换1次机会`;
        } else if (type == 17) {
          if (item.giveType == 0) {
            str =
              orderCountType == 0
                ? `每1个订单赠送1次抽卡机会`
                : `完成任务赠送1次抽卡机会`;
          } else if (item.giveType == 1) {
            this.taskLevelList.forEach((it) => {
              str = `购买商品，每满${
                item.countType == 1
                  ? it.limit + "元"
                  : item.countType == 2
                  ? it.limit + "件"
                  : item.countType == 3
                  ? it.limit + "笔"
                  : ""
              }可赠送${it.giveNum}次抽卡机会`;
            });
          } else if (item.giveType == 2) {
            str = `购买商品：`;
            this.taskLevelList.forEach((it) => {
              str =
                str +
                `\n满${
                  item.countType == 1
                    ? it.limit + "元"
                    : item.countType == 2
                    ? it.limit + "件"
                    : item.countType == 3
                    ? it.limit + "笔"
                    : ""
                }可赠送${it.giveNum}次抽卡机会；`;
            });
          }
        } else if (type == 18) {
          str = `成功邀请好友入会${condition}次，赠送1次抽卡机会`;
        } else if (type == 5) {
          str = `成功浏览会场${item.viewTime || 1}秒，赠送${item.giveLimit || 1}次抽卡机会`;
        } else if (type == 23) {
          str = `成功查询关键词，赠送1次抽卡机会`;
        }
        return str;
      };
    },
    // 获取任务次数
    getCount() {
      return (item) => {
        const {
          type,
          count,
          inviteLimit,
          condition2,
          activityType,
          orderCountType,
        } = item;
        let str = count;
        if (type == 12 || type == 11 || type == 4) {
          str = `活动期间最多完成${condition2}次`;
        } else if (type == 8) {
          str = `活动期间最多完成${inviteLimit}次`;
        } else if (type == 16) {
          str = `${
            activityType == 2 ? "活动期间" : "活动期间每日"
          }最多完成${condition2}次`;
        } else if (type == 17 && item.giveType == 0) {
          str = `活动期间最多完成${orderCountType == 0 ? condition2 : "1"}次`;
        } else if (type == 17 && item.giveType != 0) {
          str =
            item.taskDoType == 0
              ? "活动期间不限次数"
              : `活动期间最多获得${item.condition2}次抽卡机会`;
        } else if (type == 18) {
          str = `活动期间最多完成${condition2}次`;
        }
        return str;
      };
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
  },
  created() {
    this.sharePic = this.getDefaultSharePic(62);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.getDetail();
    this.buriedPoint(1, "集卡有礼", "互动管理", "互动活动");
  },

  methods: {
    viewMergeLogic() {
         window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#");
    },
    initData() {
      this.taskForm.venderIds = this.taskForm.venderIds&&this.taskForm.venderIds.length> 0 ? this.taskForm.venderIds : [this.venderId];
      this.taskForm.sellerSkuList = this.taskForm.sellerSkuList&&this.taskForm.sellerSkuList.length> 0 ? this.taskForm.sellerSkuList : [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, this.taskForm.venderIds);
    },
    changePrizeType(val) {
      this.ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber = "";
      this.ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber = "";
      this.ruleForm.ruleDTO.lotteryRule.oneDayMaxRewardNumber = "";
      this.ruleForm.ruleDTO.lotteryRule.totalMaxRewardNumber = "";
      this.ruleForm.ruleDTO.lotteryRule.statisticsRule = 0;
      this.ruleForm.ruleDTO.exchangeRule.exchangeType = 0;
      this.ruleForm.ruleDTO.exchangeRule.exchangeNumber = "";
      this.ruleForm.ruleDTO.exchangeRule.prizeRule = 0;
      this.ruleForm.ruleDTO.exchangeRule.statisticsRule = 0;
      this.bigTurntableDrawPrizeDTOS = [
        {
          index: 0,
          assetsId: null,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          assetsId: null,
          predictSendTime: "",
          isFollowActivityEndTime: 1,
          addressFillEndTime: "",
        }
      ];
    },
    handleChangeExchangeType(val) {
      if (val == 0) {
        this.ruleForm.ruleDTO.exchangeRule.exchangeNumber = "";
      }
    },
    changeRule(row) {
      if (row.statisticsRule == 0) {
        row.collectCardNum = "";
      } else {
        row.collectSetNum = "";
      }
    },
    limitInputFn(e) {
      // 实现当前输入小于配置的张卡片乘以设置的张图的碎片数量
      let filtered = e.replace(/[^\d]/g, ""); // 只保留数字
      if (filtered === "") return "";

      // 转为数字进行判断
      let num = parseInt(filtered);

      // 判断输入必须大于0
      if (filtered <= 0) {
        this.$message.warning("请输入大于0的数值");
        return "";
      }

      const cardCount =
        this.selectedIndex != -1
          ? this.collectCardList.filter((item) => !item.isKeyCard).length
          : this.collectCardList.length;
      // 获取每张图的碎片数量
      const shardNumber = this.ruleForm.ruleDTO.shardNumber;

      // 计算最大允许值：卡片数量 * 碎片数量
      const maxAllowed = cardCount * shardNumber;

      // 如果输入值大于最大允许值，则使用最大允许值
      if (num > maxAllowed) {
        num = maxAllowed.toString();
        this.$message.warning("不重复数量不得大于碎片数量");
      }

      return num;
    },
    changeCardType(val) {
      if (val == 0) {
        this.ruleForm.ruleDTO.lotteryRule.statisticsRule = 0;
      }
    },
    deleteStep(index) {
      this.stepList.splice(index, 1);
      this.stepList.forEach((item, i) => {
        item.taskIndex = i + 1;
      });
    },
    downloadTemplate() {
      this.downloadTemplateUrl =
        "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/集卡有礼.psd";
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = this.downloadTemplateUrl;
      // 将生成的URL设置为a.href属性
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    checkDesign(type) {
      isShowDesignSpecifications = true;
      if (type == 1) {
        this.designSpecificationsUrl = "";
      } else {
        this.designSpecificationsUrl = "";
      }
    },

    async beforeUploadBtn(file) {
      const status = await this.imgchecked(file, 292, 120);
      if (!status) {
        return false;
      }
      const isLt300K = file.size < 300 * 1024;
      let type1 = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (sorts.indexOf(type1) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
      if (!isLt300K) {
        this.$message.info("上传图片大小不能超过300KB");
        return false;
      }
    },
    async beforeUploadBtn2(file) {
      const status = await this.imgchecked(file, 308, 94);
      if (!status) {
        return false;
      }
      const isLt300K = file.size < 300 * 1024;
      let type1 = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (sorts.indexOf(type1) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
      if (!isLt300K) {
        this.$message.info("上传图片大小不能超过300KB");
        return false;
      }
    },
    handleUploadBtn(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.customerPaperwork.drawCardUrl = res.data;
      }
    },
    handleUploadBtn2(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.customerPaperwork.drawPrizeUrl = res.data;
      }
    },
    selectStepPrize(currentIndex, row, index) {
      this.currentStepIndex = currentIndex;
      this.currentStepPrizeIndex = index;
      this.currentStepPrize = row;
      this.showStepPrize = true;
      this.$nextTick(() => {
        this.$refs.stepPrizeRef.openDialog();
      });
    },
    // 添加单个阶梯奖品
    addSigleStepList(item) {
      if (item.stepPrizeDTO.length >= 4) {
        this.$message.warning("最多添加4个奖品");
        return;
      }
      item.stepPrizeDTO.push({
        assetsId: null,
        title: "",
        price: null,
        logo: "",
        totalAmount: "",
        prizeType: null,
        predictSendTime: "",
        isFollowActivityEndTime: 1,
        addressFillEndTime: "",
      });
    },
    // 添加阶梯
    addStepPrize() {
      if (this.stepList.length >= 5) {
        this.$message.warning("最多添加5个阶梯");
        return;
      }
      this.stepList.push({
        taskIndex: this.stepList.length + 1,
        statisticsRule: 0,
        collectSetNum: "",
        collectCardNum: "",
        stepPrizeDTO: [
          {
            assetsId: null,
            title: "",
            price: null,
            logo: "",
            totalAmount: "",
            prizeType: null,
            predictSendTime: "",
            isFollowActivityEndTime: 1,
            addressFillEndTime: "",
          },
        ],
      });
    },
    delStepPrize(list, stepIndex) {
      list.splice(stepIndex, 1);
    },
    delUnifiedPrize(index) {
      this.bigTurntableDrawPrizeDTOS.splice(index, 1);
    },
    addUnifiedPrize() {
      if (this.bigTurntableDrawPrizeDTOS.length >= 4) {
        this.$message.warning("最多添加4个奖品");
        return;
      }
      this.bigTurntableDrawPrizeDTOS.push({
        index: this.bigTurntableDrawPrizeDTOS.length - 1,
        assetsId: null,
        title: "",
        price: null,
        logo: "",
        totalAmount: "",
        prizeType: null,
        predictSendTime: "",
        isFollowActivityEndTime: 1,
        addressFillEndTime: "",
      });
    },
    getStepData(data, prizeType) {
      if (prizeType == 1) {
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "couponType",
          data.couponType
        );
      }
      if (data.giftType) {
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "giftType",
          Number(data.giftType)
        );
      }
      this.$set(
        this.stepList[this.currentStepIndex].stepPrizeDTO[
          this.currentStepPrizeIndex
        ],
        "price",
        Number(data.discount)
      );
      this.$set(
        this.stepList[this.currentStepIndex].stepPrizeDTO[
          this.currentStepPrizeIndex
        ],
        "assetsId",
        Number(data.couponId|| data.skuId)
      );
      this.$set(
        this.stepList[this.currentStepIndex].stepPrizeDTO[
          this.currentStepPrizeIndex
        ],
        "logo",
        data.logo || this.defaultLogo
      );
      this.$set(
        this.stepList[this.currentStepIndex].stepPrizeDTO[
          this.currentStepPrizeIndex
        ],
        "prizeType",
        prizeType
      );
      this.$set(
        this.stepList[this.currentStepIndex].stepPrizeDTO[
          this.currentStepPrizeIndex
        ],
        "title",
        data.name
      );

      if (data.singleAmount) {
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "singleAmount",
          data.singleAmount
        );
      }
      if (prizeType == 2) {
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "quantityTotal",
          data.quantityTotal
        );
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.$set(
            this.stepList[this.currentStepIndex].stepPrizeDTO[
              this.currentStepPrizeIndex
            ],
            "skuId",
            data.skuId
          );
          delete this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ].isGoodManage;
        } else {
          this.$set(
            this.stepList[this.currentStepIndex].stepPrizeDTO[
              this.currentStepPrizeIndex
            ],
            "isGoodManage",
            data.isGoodManage
          );
        }
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "addressFillEndTime",
          data.addressFillEndTime
        );
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "isFollowActivityEndTime",
          data.isFollowActivityEndTime
        );
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "predictSendTime",
          data.predictSendTime
        );
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "shouldCollectExtraData",
          data.shouldCollectExtraData
        );
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "addressFillLimit",
          data.addressFillLimit
        );
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "commitAddressLimit",
          data.commitAddressLimit
        );
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "extraQuestion",
          data.extraQuestion
        );
      }
      if (prizeType == 4) {
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "title",
          data.discount + "店铺积分"
        );
      } else {
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "title",
          data.name
        );
      }
      // 实物随单发
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "budgetRemain",
          data.budgetRemain
        );
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.$set(
          this.stepList[this.currentStepIndex].stepPrizeDTO[
            this.currentStepPrizeIndex
          ],
          "budgetRemain",
          data.budgetRemain
        );
      }
      this.showStepPrize = false;
    },
    getUnifiedData(data, prizeType) {
      if (prizeType == 1) {
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].couponType =
          data.couponType;
      }
      if (data.giftType) {
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].giftType = Number(
          data.giftType
        );
      }
      this.bigTurntableDrawPrizeDTOS[this.currentIndex].price = Number(
        data.discount
      );

      this.bigTurntableDrawPrizeDTOS[this.currentIndex].assetsId = Number(
        data.couponId || data.skuId
      );
      this.bigTurntableDrawPrizeDTOS[this.currentIndex].logo =
        data.logo || this.defaultLogo;
      this.bigTurntableDrawPrizeDTOS[this.currentIndex].prizeType = prizeType;
      this.bigTurntableDrawPrizeDTOS[this.currentIndex].title = data.name;

      if (data.singleAmount) {
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].singleAmount =
          data.singleAmount;
      }
      if (prizeType == 2) {
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].quantityTotal =
          data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          this.bigTurntableDrawPrizeDTOS[this.currentIndex].skuId = data.skuId;
          delete this.bigTurntableDrawPrizeDTOS[this.currentIndex].isGoodManage;
        } else {
          this.bigTurntableDrawPrizeDTOS[this.currentIndex].isGoodManage =
            data.isGoodManage;
        }
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].addressFillEndTime =
          data.addressFillEndTime;
        this.bigTurntableDrawPrizeDTOS[
          this.currentIndex
        ].isFollowActivityEndTime = data.isFollowActivityEndTime;
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].predictSendTime =
          data.predictSendTime;
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].shouldCollectExtraData = data.shouldCollectExtraData;
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].extraQuestion = data.extraQuestion;
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].addressFillLimit =
          data.addressFillLimit;
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].commitAddressLimit =
          data.commitAddressLimit;
      }
      // 实物随单发
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.bigTurntableDrawPrizeDTOS[this.currentIndex],prizeType,data);
      }
      if (prizeType == 4) {
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].title =
          data.discount + "店铺积分";
      } else {
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].title = data.name;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].budgetRemain =
          data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.bigTurntableDrawPrizeDTOS[this.currentIndex].budgetRemain =
          data.budgetRemain;
      }
      this.showUnifiedPrize = false;
    },
    // 选择统一奖品
    selectUnifiedPrize(row, index) {
      this.currentIndex = index;
      this.unifiedJingdouCount.prizeCount = row.totalAmount;
      this.currentUnifiedPrize = row;
      this.showUnifiedPrize = true;
      this.$nextTick(() => {
        this.$refs.unifiedPrizeRef.openDialog();
      });
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve(true);
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    // 奖品logo校验
    async beforeUpload(file) {
      const status = await this.imgchecked(file, 200, 200);
      if (!status) {
        return false;
      }
      const isLt300K = file.size < 300 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (!isLt300K) {
        this.$message.info("上传图片大小不能超过300KB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 统一奖品上传图片
    handleUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        row.logo = res.data;
      }
    },
    // 阶梯奖品上传图片
    handleStepUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        row.logo = res.data;
      }
    },
    clearKeyCardTime() {
      if (this.activityData.isStart) {
        return;
      }
      this.ruleForm.ruleDTO.keyCardStartTime = "";
      this.ruleForm.ruleDTO.keyCardEndTime = "";
    },
    handleKeyCardClick(index, item) {
      // 如果点击的是已选中的关键卡，则取消选择
      if (item.isSelect == index) {
        item.isKeyCard = false;
        this.selectedIndex = -1;
        item.isSelect = -1;
      } else {
        // 取消所有卡片的关键卡状态（确保互斥）
        this.collectCardList.forEach((card) => {
          card.isKeyCard = false;
          card.isSelect = -1;
        });
        // 设置当前卡片为关键卡
        item.isKeyCard = true;
        item.isSelect = index;
        this.selectedIndex = index;
      }
    },
    // 添加卡片
    addCard() {
      if (this.collectCardList.length >= 10) {
        this.$message.warning("最多只能添加10张卡片");
        return;
      }
      this.collectCardList.push({
        id: null,
        activityId: "",
        title: "",
        pictureUrl: "",
        percentage: "",
        cardLimitNumber: "",
        isKeyCard: false,
        isSelect: -1,
        fileList: [],
      });
    },

    // 删除卡片
    deleteCard(row, index) {
      this.$confirm("确定要删除该卡片吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (row.isKeyCard) {
            this.ruleForm.ruleDTO.keyCardStartTime = "";
            this.ruleForm.ruleDTO.keyCardEndTime = "";
            this.selectedIndex = -1;
          }
          this.collectCardList.splice(index, 1);
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },

    // 处理概率输入
    handleProbabilityInput(item) {
      if (item.percentage < 0) {
        item.percentage = 0;
      } else if (item.percentage > 100) {
        item.percentage = 100;
      }

      // 计算总概率，确保不超过100%
      let totalProbability = 0;
      this.collectCardList.forEach((card) => {
        totalProbability += Number(card.percentage) || 0;
      });

      if (
        this.ruleForm.ruleDTO.isKeyCardThanks == 1 &&
        totalProbability >= 100
      ) {
        this.$message.warning(
          "配置【是否抽中谢谢参与】为是时，所有卡片概率相加不可为100%整"
        );
        item.percentage = "";
      } else {
        if (totalProbability > 100) {
          this.$message.warning(
            "配置【是否抽中谢谢参与】为否时，所有卡片概率必须配置为100%整"
          );
          item.percentage = Math.max(
            0,
            100 - (totalProbability - item.percentage)
          );
        }
      }
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.customerPaperwork.drawCardRgb = item.rgb;
      this.customerPaperwork.drawPrizeRgb = item.rgb2;
      this.customerPaperwork.cardBorderColor = item.rgb3;
      this.currrentCardRgb = item.rgb;
      this.currrentPrizeRgb = item.rgb2;
      this.cardBorderColor = item.rgb3;
      
    },
    countTypeChange() {
      this.taskLevelList.forEach((item) => {
        item.limit = "";
      });
    },
    NumChange(e, key, valueIndex) {
      let res = e;
      this.taskLevelList.forEach((item, index) => {
        if (valueIndex > index) {
          if (parseFloat(res) <= parseFloat(item[key])) {
            res = "";
          }
        }
      });
      return res;
    },
    giveTypeChange(e) {
      if (e == 1) {
        this.taskLevelList = [
          {
            taskIndex: 1,
            limit: "",
            giveNum: "",
          },
        ];
      }
      if (e == 2) {
        this.taskLevelList = [
          {
            taskIndex: 1,
            limit: "",
            giveNum: "",
          },
          {
            taskIndex: 2,
            limit: "",
            giveNum: "",
          },
        ];
      }
    },
    addTaskLevel() {
      let postData = {
        taskIndex: 1,
        limit: "",
        giveNum: "",
      };
      postData.taskIndex = this.taskLevelList.length + 1;
      this.taskLevelList.push(postData);
    },
    delTaskLevel(index) {
      this.taskLevelList.splice(index, 1);
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      if (this.isStepStr) {
        this.stepList[this.currentStrStepIndex][toAddBelong][
          toAddIndex
        ].totalAmount = num;
      } else {
        this[toAddBelong][toAddIndex].totalAmount = num;
      }
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.isStepStr = false;
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 阶梯奖品增加库存
    addStepPrizeDTONum(arrStr, stepIndex, index) {
      this.isStepStr = true;
      this.currentStrStepIndex = stepIndex;
      this.toAddItem = {
        ...this.stepList[stepIndex][arrStr][index],
        num: this.stepList[stepIndex][arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title) {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = "";
      this.ruleForm.goShopUrl = "";
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    inp(val) {
      this.$forceUpdate();
    },
    // 京东计划数量计算
    prizeNum(row) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        const valid = image.width == 200 && image.height == 200;
        file.isFlag = valid;
        _this.uploadSize = valid;
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.info("图片宽高不符合要求,请重新上传");
          sizetype = false;
          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        console.log(this.uploadSize);
        if (this.uploadSize) {
          this.ruleForm.sharePic = res.data;
          this.$forceUpdate();
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleForm.sharePic = this.sharePic;
      this.$forceUpdate();
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        this.templateId = this.giftList[0].id;
        this.templateJson.templateUItype = 0;
        this.customerPaperwork.drawCardRgb = this.giftList[0].rgb;
        this.customerPaperwork.drawPrizeRgb = this.giftList[0].rgb2;
        this.currrentCardRgb = this.giftList[0].rgb;
        this.currrentPrizeRgb = this.giftList[0].rgb2;
        this.cardBorderColor = this.giftList[0].rgb3;
        this.templateObj = this.giftList[0];
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        this.customerPaperwork.drawCardRgb = this.customerPaperwork.drawCardRgb;
        this.customerPaperwork.drawPrizeRgb = this.customerPaperwork.drawPrizeRgb;
        this.currrentCardRgb = this.templateObj.rgb;
        this.currrentPrizeRgb = this.templateObj.rgb2;
        this.cardBorderColor = this.templateObj.rgb3;
      }
      this.pageData.total = data.total * 1;
    },

    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },

    selectGoodsClose(data) {
      if (data) {
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        this.selectGoodsArr = this.itemListFor;
      }
      this.selectGoodsState = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$forceUpdate();
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    checkLimit(row, min) {
      let newVal = (row.dailyLimit + "").replace(/[^\d]/g, "");
      if (newVal) {
        if (newVal < min) {
          return "";
        } else {
          if (Number(row.dailyLimit) > Number(row.totalAmount)) {
            this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
            return "";
          } else {
            return Number(row.dailyLimit);
          }
        }
      }
    },
    //上传图片
    handleChange(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        row.pictureUrl = res.data;
        // 更新文件列表
        row.fileList = [{ url: res.data }];
      }
    },
    handleRemove(file, fileList, row) {
      row.logo = "";
      row.fileList = [];
    },
    // getCondition(item) {
    //   const { type, condition, orderCountType } = item;
    //   let str = condition;
    //   if (type == 13) {
    //     str = `成功浏览${condition}件商品，赠送1次抽卡机会`;
    //   } else if (type == 4) {
    //     str = `成功加购${condition}件商品，赠送1次抽卡机会`;
    //   } else if (type == 9) {
    //     str = `成功分享${condition}次商品，赠送1次抽卡机会`;
    //   } else if (type == 10) {
    //     str = `成功分享${condition}次店铺，赠送1次抽卡机会`;
    //   } else if (type == 11) {
    //     str = `成功分享${condition}次活动，赠送1次抽卡机会`;
    //   } else if (type == 12) {
    //     str = `每成功预约${condition}件商品，赠送1次抽卡机会`;
    //   } else if (type == 16) {
    //     str = `每${condition}积分可兑换1次机会`;
    //   } else if (type == 17) {
    //     if (item.giveType == 0) {
    //       str =
    //         orderCountType == 0
    //           ? `每1个订单赠送1次抽卡机会`
    //           : `完成任务赠送1次抽卡机会`;
    //     } else if (item.giveType == 1) {
    //       this.taskLevelList.forEach((it) => {
    //         str = `购买商品，每满${
    //           item.countType == 1
    //             ? it.limit + "元"
    //             : item.countType == 2
    //             ? it.limit + "件"
    //             : item.countType == 3
    //             ? it.limit + "笔"
    //             : ""
    //         }可赠送${it.giveNum}次抽卡机会`;
    //       });
    //     } else if (item.giveType == 2) {
    //       str = `购买商品：`;
    //       this.taskLevelList.forEach((it) => {
    //         str =
    //           str +
    //           `\n满${
    //             item.countType == 1
    //               ? it.limit + "元"
    //               : item.countType == 2
    //               ? it.limit + "件"
    //               : item.countType == 3
    //               ? it.limit + "笔"
    //               : ""
    //           }可赠送${it.giveNum}次抽卡机会；`;
    //       });
    //     }
    //   } else if (type == 18) {
    //     str = `成功邀请好友入会${condition}次，赠送1次抽卡机会`;
    //   }
    //   return str;
    // },
    //生成规则
    generateRule() {
      let text1 = "",
        text2 = "",
        text3 =  "",
        text4 = "有效订单不包含售中退款/售后退款，如成功参与活动的用户对商品订单进行售后行为，导致实际支付金额不足活动门槛金额的，或者因客户原因导致的恶意退款，视为用户不符合中奖资格，商家有权取消该用户获取奖品的资格;",
        text5 = "获取奖品方式：",
        text6 = "若用户存在刷奖等恶意行为，一经发现将取消获奖资格（如奖品已经发放，有权追回奖品）；",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【注意事项】";
      const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleForm.ruleDTO,this.actMember)
      if(this.ruleForm.ruleDTO.cardDrawType==0) {
        text1 = "参与方式：按要求完成“指定任务”后可获得抽卡机会，在活动期间进入活动手动抽取卡片；";
        let conditionText = "";
        this.taskDataList.forEach((item,index)=>{
          conditionText +=  `（${index+1}）${this.getCondition(item)}`
          if(index<this.taskDataList.length-1){
            conditionText += "\n"
          }
        }) 
        text2 = "抽卡条件："
        if(this.taskDataList.length>0) {
          text2 += "\n" + conditionText
        }
      } else {
        text1 = "参与方式：消耗积分可获得抽卡机会，在活动期间进入活动手动抽取卡片；"
        text2 = `用户消耗${this.ruleForm.ruleDTO.consumePoint}积分抽卡一次;`
      }

      if (this.ruleForm.ruleDTO.prizeType == 0) {
        text5 += "集卡抽奖，即按要求集齐卡片后可以参与抽奖，有机会获取奖品；";
      } else {
        text5 += `集卡兑换，即按要求集齐卡片后可以兑换奖品；${this.ruleForm.ruleDTO.exchangeRule.exchangeType==0?"仅可兑换一次；": (this.ruleForm.ruleDTO.exchangeRule.exchangeNumber ? ('活动期间每人可兑换'+this.ruleForm.ruleDTO.exchangeRule.exchangeNumber+'次；' ) : '')}`;
      }
      if(this.ruleForm.ruleDTO.prizeType==0) {
        if(this.ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber&&!this.ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber) {
          text3 =  `抽奖限制：活动期间每人，每天最多抽奖${this.ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber}次；`
        } else if(this.ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber&&!this.ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber) {
          text3 = `抽奖限制：活动期间累计最多抽奖${this.ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber}次`
        } else if(this.ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber&&this.ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber) {
          text3 =  `抽奖限制：活动期间每人，每天最多抽奖${this.ruleForm.ruleDTO.lotteryRule.oneDayMaxDrawNumber}次，累计最多抽奖${this.ruleForm.ruleDTO.lotteryRule.totalMaxDrawNumber}次`
        }
      }
      // let Arr1 = [text1, text2, text3, plusText, text4, text5, text6, text7];
      // let newText = "";
      // let newNum = 1;
      // Arr1.forEach((item) => {
      //   if (item.length > 0) {
      //     newText = newText + newNum + "." + item + ";" + "\n";
      //     newNum = newNum + 1;
      //   }
      // });
      let Arr1 = [
        firstText,
        [secondText, text1, text2,text3,text4,text5,text6],
        [thirdText, precautions],
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText;
    },
    //清除
    cleanData(row, index) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.memberBuyPercentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.dailyLimitType = 0;
      row.dailyLimit = null;
      row.busyLimit = null;
      row.idleLimit = null;
      row.singleMaxWin = "";
      row.shouldCollectExtraData = 0
      row.extraQuestion = null
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(5);
      }
    },
    //选择奖品弹窗
    centerVis(row) {
      this.itemArr = this.prizeSettingList;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.index = row.index;
      this.echoDate = row;
      this.isSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        this.prizeSettingList[this.index].goShopSetting = data.goShopSetting;
        this.prizeSettingList[this.index].goShopAppId = data.goShopAppId;
        this.prizeSettingList[this.index].goShopUrl = data.goShopUrl;
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price = Number(data.discount);
      this.prizeSettingList[this.index].assetsId = Number(data.couponId || data.skuId);
      this.$set(this.prizeSettingList[this.index], "logo", data.logo);
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        this.prizeSettingList[this.index].title = data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        this.prizeSettingList[this.index].addressFillEndTime =
          data.addressFillEndTime;
        this.prizeSettingList[this.index].predictSendTime =
          data.predictSendTime;
        this.prizeSettingList[this.index].isFollowActivityEndTime =
          data.isFollowActivityEndTime;
        this.prizeSettingList[this.index].shouldCollectExtraData = data.shouldCollectExtraData;
        this.prizeSettingList[this.index].extraQuestion = data.extraQuestion;
        this.prizeSettingList[this.index].addressFillLimit = data.addressFillLimit;
        this.prizeSettingList[this.index].commitAddressLimit = data.commitAddressLimit;
        if (!data.isGoodManage) {
          this.prizeSettingList[this.index].skuId = data.skuId;
          delete this.prizeSettingList[this.index].isGoodManage;
        } else {
          this.prizeSettingList[this.index].isGoodManage = data.isGoodManage;
        }
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.prizeSettingList[this.index],prizeType,data);
      }
      this.isSelectProduct = false;
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleForm.ruleDTO.openCardStartTime ||
            !this.ruleForm.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }

      // 抽奖机会
      if (this.ruleForm.ruleDTO.cardDrawType == 0) {
        let falg = false;
        if (this.cardDrawGiveType == 0) {
          if (!this.ruleForm.ruleDTO.firstGiveTimes) {
            falg = true;
          }
        } else {
          if (!this.ruleForm.ruleDTO.everyDayGiveTimes) {
            falg = true;
          }
        }
        if (falg) {
          return this.$message.warning("请完善抽奖机会信息");
        }
      } else {
        if (!this.ruleForm.ruleDTO.consumePoint) {
          return this.$message.warning("请完善抽奖机会信息");
        }
      }
      // 任务校验
      if (this.taskDataList.length > 0) {
        // 检查邀请好友入会任务（type==18）的时间配置
        for (let task of this.taskDataList) {
          if (task.type == 18 && task.taskTime == 2) {
            if (
              task.startTime < this.ruleForm.startTime ||
              task.endTime > this.ruleForm.endTime
            ) {
              this.$message.warning("邀请好友入会任务配置有误");
              return;
            }
          }
        }
      }
      // 卡片设置概率
      let isKeyCardThanks = false;
      let isUrl = false;
      let isTitlee = false;
      this.collectCardList.some((item) => {
        if (item.percentage == "") {
          isKeyCardThanks = true;
        }
        if (!item.pictureUrl) {
          isUrl = true;
        }
        if (!item.title) {
          isTitlee = true;
        }
      });
      if (isUrl) {
        return this.$message.warning("卡片图片不可为空");
      }
      if (isTitlee) {
        return this.$message.warning("卡片名称不可为空");
      }
      if (isKeyCardThanks) {
        return this.$message.warning("卡片设置概率不可为空");
      }

      // 选择抽中谢谢参与时卡片概率相加
      let totalProbability = this.collectCardList.reduce((acc, cur) => {
        return acc + Number(cur.percentage || 0);
      }, 0);

      if (
        this.ruleForm.ruleDTO.isKeyCardThanks == 1 &&
        totalProbability >= 100
      ) {
        this.$message.warning(
          "配置【是否抽中谢谢参与】为是时，所有卡片概率相加不可为100%整"
        );
        return;
      }

      if (
        this.ruleForm.ruleDTO.isKeyCardThanks == 0 &&
        totalProbability < 100
      ) {
        this.$message.warning(
          "配置【是否抽中谢谢参与】为否时，所有卡片概率必须配置为100%整"
        );
        return;
      }
      // 配置【是否抽中谢谢参与】为否时，所有卡片概率必须配置为100%整

      if (this.selectedIndex != -1) {
        if (
          !this.ruleForm.ruleDTO.keyCardStartTime ||
          !this.ruleForm.ruleDTO.keyCardEndTime
        ) {
          return this.$message.warning("关键卡开启时间不能为空");
        }
        if (
          this.ruleForm.ruleDTO.keyCardStartTime &&
          this.ruleForm.ruleDTO.keyCardEndTime
        ) {
          if (
            new Date(this.ruleForm.ruleDTO.keyCardStartTime).valueOf() >
            new Date(this.ruleForm.ruleDTO.keyCardEndTime).valueOf()
          ) {
            return this.$message.warning(
              "关键卡开启开始时间不能大于关键卡开启结束时间"
            );
          }
        }
        if (this.ruleForm.startTime && this.ruleForm.endTime) {
          if (
            new Date(this.ruleForm.ruleDTO.keyCardStartTime).valueOf() <
            new Date(this.ruleForm.startTime).valueOf()
          ) {
            return this.$message.warning(
              "关键卡开启开始时间不能小于活动开始时间"
            );
          }
          if (
            new Date(this.ruleForm.ruleDTO.keyCardEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
          ) {
            return this.$message.warning(
              "关键卡开启结束时间不能大于活动结束时间"
            );
          }
        }
      }
      if (this.ruleForm.ruleDTO.collectCardType == 1) {
        if (
          this.ruleForm.ruleDTO.isRepeatRule &&
          !this.ruleForm.ruleDTO.repeatNumber
        ) {
          return this.$message.warning("请输入重复抽中次数");
        }
        if (this.ruleForm.ruleDTO.isRepeatRule) {
          const cardCount =
            this.selectedIndex != -1
              ? this.collectCardList.filter((item) => !item.isKeyCard).length
              : this.collectCardList.length;
          // 获取每张图的碎片数量
          const shardNumber = this.ruleForm.ruleDTO.shardNumber;
          // 计算最大允许值：卡片数量 * 碎片数量
          const maxAllowed = cardCount * shardNumber;

          // 如果输入值大于最大允许值，则使用最大允许值
          if (Number(this.ruleForm.ruleDTO.repeatNumber) > maxAllowed) {
            return this.$message.warning("不重复数量不得大于碎片数量");
          }
        }
      }

      // 请将奖品填写完整！
      const hasValidPrize = this.prizeSettingList.some(
        (item) => item.prizeType != 9
      );
      if (!hasValidPrize && this.ruleForm.ruleDTO.prizeType == 0) {
        return this.$message.warning("奖品项至少有一个非谢谢参与类型奖项");
      }
      const isFlay = this.prizeSettingList.some(
        (item) => item.prizeType != 9 && !item.totalAmount
      );
      if (isFlay && this.ruleForm.ruleDTO.prizeType == 0) {
        return this.$message.warning("请将奖品填写完整！");
      }

      // 统一奖品
      let flag1 = false;
      this.bigTurntableDrawPrizeDTOS.some((item) => {
        if (!item.title || !item.totalAmount|| !item.prizeType) {
          flag1 = true;
          return true;
        }
      });
      // 阶梯奖品
      // 1. 集满统计规则
      let flag2 = false;
      this.stepList.some((item) => {
        if (
          (item.statisticsRule == 0 && !item.collectSetNum) ||
          (item.statisticsRule == 1 && !item.collectCardNum)
        ) {
          flag2 = true;
          return true;
        }
      });
      // 2.阶梯奖品校验
      let flag3 = false;
      this.stepList.some((stepItem) => {
        // 检查stepPrizeDTO数组是否存在且不为空
        if (stepItem.stepPrizeDTO && stepItem.stepPrizeDTO.length > 0) {
          // 遍历阶梯中的每个奖品对象
          return stepItem.stepPrizeDTO.some((prizeItem) => {
            // 检查奖品的必填字段
            if (
              !prizeItem.title ||
              !prizeItem.totalAmount ||
              !prizeItem.prizeType
            ) {
              flag3 = true;
              return true; // 找到未填写完整的奖品，退出遍历
            }
            return false;
          });
        } else {
          // 如果stepPrizeDTO不存在或为空，也视为未填写完整
          flag3 = true;
          return true;
        }
      });
      if (this.ruleForm.ruleDTO.prizeType == 1) {
        if (flag1 && this.ruleForm.ruleDTO.exchangeRule.prizeRule == 0) {
          return this.$message.warning("请将统一奖品填写完整！");
        }
        if (flag2 && this.ruleForm.ruleDTO.exchangeRule.prizeRule == 1) {
          return this.$message.warning("请完善阶梯设置的统计规则");
        }
        if (flag3 && this.ruleForm.ruleDTO.exchangeRule.prizeRule == 1) {
          return this.$message.warning("请将阶梯奖品填写完整！");
        }
      }

      if (!this.validateStepRules()) {
        return;
      }
      // 公活动配置校验
      // if (!useValidateMoreActSet(this)) {
      //   return;
      // }

      //新增进店设置校验
      if (this.ruleForm.ruleDTO.goShopSetting == 1 && !this.ruleForm.ruleDTO.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleForm.ruleDTO.goShopSetting == 2) {
        if (!this.ruleForm.ruleDTO.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleForm.ruleDTO.goShopUrl.startsWith("https://") ||
          !this.ruleForm.ruleDTO.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    async handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType;
      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow;
      obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay;

      obj.ruleDTO.shareTitle = this.ruleForm.shareTitle;
      obj.ruleDTO.shareIntroduce = this.ruleForm.shareIntroduce;
      obj.ruleDTO.sharePic = this.ruleForm.sharePic;
      // 是否重点活动
      obj.isKeyActivity = this.isKeyActivity
      obj.placementPosition = this.placementPosition.join(",")

      // 任务
      if (this.taskDataList.length) {
        obj.taskList = this.taskDataList.map((item) => {
          const taskObj = {
            activityType:
              item.type == 8 ||
              item.type == 12 ||
              item.type == 7 ||
              item.type==11||
              item.type==4||
              (item.type == 16 && item.activityType == 2)
                ? 2
                : 1,
            taskType: item.type,
            taskValidity: item.taskTime,
          };
          if (item.id) {
            taskObj.id = item.id;
          }
          // 指定时间
          if (item.taskTime == 2) {
            taskObj.startTime = item.startTime;
            taskObj.endTime = item.endTime;
          }
          // 商品
          if (item.skuIds.length) {
            taskObj.skuIds = item.skuIds.join(",");
          }
          if (item.type == 18) {
            taskObj.activityType = 2;
            taskObj.inviteLimit = item.condition;
            taskObj.taskDoLimit = item.condition2;
          }
          // 浏览会场-跳转链接
          if (item.type == 5) {
            taskObj.jumpUrl = item.jumpUrl;
            taskObj.viewTime = item.viewTime;
            taskObj.giveLimit = item.giveLimit;
          }
          // 搜索关键词
          if (item.type == 23) {
            taskObj.searchKeyword = item.searchKeyword;
            taskObj.activityType = 1;
            taskObj.giveLimit = 1;
          }
          // 好友助力-邀请人数上限
          if (item.type == 8) {
            taskObj.inviteLimit = item.inviteLimit;
          }
          if (item.type == 17) {
            taskObj.activityType = 2;
            taskObj.orderCountType = item.orderCountType;
            taskObj.orderType = item.orderType;
            taskObj.skuType = item.skuType;
            // 指定商品规则提交，老数据无该字段时默认整单计算
            taskObj.statsSkuType = item.statsSkuType || 0;
            taskObj.itemTotalLimit = item.itemTotalLimit;
            taskObj.amtLimit = item.amtLimit;
            taskObj.orderStartTime = item.orderStartTime;
            taskObj.orderEndTime = item.orderEndTime;

            taskObj.giveType = item.giveType;
            taskObj.countType = item.countType;
            taskObj.taskDoType = item.taskDoType;
            if(item.giveType == 0){
              taskObj.taskDoType = 1
            }
            taskObj.venderIds = item.venderIds;
            taskObj.stepList = item.stepList;
            taskObj.venderIds = item.venderIds.join(",");
            taskObj.sellerSkuList = item.sellerSkuList.map((item)=>{
              return {
                skuIds: item.skuIds,
                venderId: item.venderId,
              }
            });
            taskObj.orderPaymentType = item.orderPaymentType;
            taskObj.mergeOrder = item.mergeOrder || false;
          }
          // 任务门槛上限
          if (this.conditionValue.includes(item.type)) {
            if (item.type == 12 || item.type == 16 || item.type==11) {
              taskObj.giveLimit = item.condition;
              taskObj.taskDoLimit = item.condition2;
            } else if (item.type == 4) {
              // 加购商品
              taskObj.addCartLimit = item.condition;
              taskObj.taskDoLimit = item.condition2;
            } else if (item.type == 17) {
              taskObj.giveLimit = 1;
              if((item.giveType == 0&&item.orderCountType == 0) || ((item.giveType == 1 || item.giveType == 2)&&item.taskDoType == 1)) {
                taskObj.taskDoLimit = item.condition2
              } else {
                taskObj.taskDoLimit = 1
              }
            } else {
              taskObj.giveLimit = item.condition;
            }
          }
          if (item.type == 7){
            taskObj.giveLimit = item.giveLimit
          }
          return taskObj;
        });
        obj.ruleDTO.taskList = obj.taskList;
      } else {
        obj.taskList = [];
      }

      // 卡片设置
      obj.collectCardList = this.collectCardList.map((item) => {
        return {
          id: this.activityData.isCopy ? null : item.id || null,
          title: item.title,
          pictureUrl: item.pictureUrl,
          percentage: item.percentage,
          cardLimitNumber: item.cardLimitNumber,
          isKeyCard: item.isKeyCard,
          keyCardStartTime: item.isKeyCard ? obj.ruleDTO.keyCardStartTime : "",
          keyCardEndTime: item.isKeyCard ? obj.ruleDTO.keyCardEndTime : "",
          keyCardEndTime: item.isKeyCard ? obj.ruleDTO.keyCardEndTime : "",
          shardNumber:
            obj.ruleDTO.collectCardType == 1 ? obj.ruleDTO.shardNumber : "",
        };
      });

      // 集卡抽奖：奖品设置
      if (this.ruleForm.ruleDTO.prizeType == 0) {
        obj.ruleDTO.lotteryRule.bigTurntableDrawPrizeDTOS = this.deepClone(
          this.prizeSettingList
        );
        obj.ruleDTO.lotteryRule.bigTurntableDrawPrizeDTOS.forEach(
          (item, index) => {
            item.percentage = Number(item.percentage);
            item.memberBuyPercentage = Number(item.memberBuyPercentage);
            if (item.prizeType != 9) {
              if (item.prizeType == 3 || item.prizeType == 10) {
                item.assetsId = item.skuId || item.assetsId;
              } else {
                item.singleAmount = 1;
              }
              if (item.prizeType == 2 || item.prizeType == 4) {
                item.singleAmount = item.price;
              }
              // 提交地址限制：数组转逗号分隔字符串
              if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                item.commitAddressLimit = item.commitAddressLimit.join(',');
              }
            }
          }
        );
      }
      //集卡兑换：统一奖品
      if (
        this.ruleForm.ruleDTO.prizeType == 1 &&
        this.ruleForm.ruleDTO.exchangeRule.prizeRule == 0 &&
        this.bigTurntableDrawPrizeDTOS.length > 0
      ) {
        obj.pointActivityPrizeDTOList = this.bigTurntableDrawPrizeDTOS.map(item => {
          const prize = { ...item };
          // 提交地址限制：数组转逗号分隔字符串
          if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
            prize.commitAddressLimit = item.commitAddressLimit.join(',');
          }
          return prize;
        });
      }

      //集卡兑换：阶梯奖品
      if (
        this.ruleForm.ruleDTO.prizeType == 1 &&
        this.ruleForm.ruleDTO.exchangeRule.prizeRule == 1 &&
        this.stepList.length > 0
      ) {
        obj.ruleDTO.exchangeRule.stepList = [];
        this.stepList.forEach((item) => {
          let stepListItem = {
            taskIndex: item.taskIndex,
            statisticsRule: item.statisticsRule,
            collectSetNum: item.collectSetNum,
            collectCardNum: item.collectCardNum,
          };
          obj.ruleDTO.exchangeRule.stepList.push(stepListItem);
          item.stepPrizeDTO.forEach((it) => {
            const prize = { ...it };
            prize.taskIndex = item.taskIndex;
            // 提交地址限制：数组转逗号分隔字符串
            if (it.prizeType == 3 && Array.isArray(it.commitAddressLimit)) {
              prize.commitAddressLimit = it.commitAddressLimit.join(',');
            }
            obj.pointActivityPrizeDTOList.push(prize);
          });
        });
      }
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleForm.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleForm.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleForm.ruleDTO.plusObject;

      obj.ruleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType;
      obj.ruleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay;
      obj.ruleDTO.openCardFollow = this.ruleForm.openCardFollow;

      // 自定义活动背景图
      obj.ruleDTO.cusTemplateJSON = this.cusTemplateJSON;

      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      delete obj.partner;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      delete obj.openCardFollow;
      if (this.checked == true || this.isDraft) {
        if (this.activityData.isStart) {
          const prizeList =
            this.ruleForm.ruleDTO.prizeType == 0
              ? obj.ruleDTO.lotteryRule.bigTurntableDrawPrizeDTOS
              : obj.pointActivityPrizeDTOList;
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeList.map((item) => {
              const prize = {
                ...item,
                prizeId: item.id,
              };
              // 提交地址限制：数组转逗号分隔字符串
              if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
                prize.commitAddressLimit = item.commitAddressLimit.join(',');
              }
              return prize;
            }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            taskList: obj.taskList,
            templateId: this.templateId,
            endTime: this.ruleForm.endTime,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveCollectCard(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getCollectCardDetail({ id: this.valueRow.id })
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              collectCardList,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              isKeyActivity,
              placementPosition,
              studentSatus,
            } = res.data;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");

            this.ruleForm.condFollow = condFollow ? true : false;
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            // 卡片设置
            this.collectCardList = collectCardList.map((item, index) => {
              if (item.isKeyCard) {
                this.selectedIndex = index;
              }
              return {
                ...item,
                isSelect: item.isKeyCard ? index : -1,
                fileList: [
                  {
                    url: item.pictureUrl,
                    name: item.title,
                  },
                ],
              };
            });

            this.ruleForm.firstOpenCardTimeType = ruleDto.firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = ruleDto.openCardBeforeDay;
            this.ruleForm.openCardFollow = ruleDto.openCardFollow;

            this.ruleForm.shareTitle = ruleDto.shareTitle;
            this.ruleForm.shareIntroduce = ruleDto.shareIntroduce;
            this.ruleForm.sharePic = ruleDto.sharePic;
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            // 是否重点活动
            this.isKeyActivity = isKeyActivity || 0
            this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"]

            this.ruleForm.isValidBlackList = res.data.isValidBlackList;

            if (ruleDto.cusTemplateJSON) {
              this.cusTemplateJSON = ruleDto.cusTemplateJSON;
            }
            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            if (ruleDto.firstGiveTimes) {
              this.cardDrawGiveType = 0;
            }
            if (ruleDto.everyDayGiveTimes) {
              this.cardDrawGiveType = 1;
            }
            this.templateId = templateId;
            this.ruleForm.ruleDTO = ruleDto;
            this.getPolite();
            this.loading = false;
            // 任务列表
            if (ruleDto.cardDrawType == 0 && ruleDto.taskList.length > 0) {
              const goodsPromise = [];
              this.taskDataList = ruleDto.taskList.map((item) => {
                const objTask = {
                  id: item.id || "",
                  type: item.taskType,
                  taskTime: item.taskValidity,
                  condition: null,
                  condition2: null,
                  count: null,
                  endTime: null,
                  startTime: null,
                  skuIds: [],
                  inviteLimit: null,
                  jumpUrl: null,
                  selectGoodsSkuList: [],
                  activityType:
                    (item.taskType == 16 || item.taskType == 17 || item.taskType == 7)
                      ? item.activityType
                      : 1,
                  skuType: 0,
                  statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
                  orderType: 0,
                  orderCountType: 1,
                  itemTotalLimit: null,
                  amtLimit: null,
                  orderEndTime: null,
                  orderStartTime: null,
                  orderPaymentType: 1,
                  mergeOrder: false,
                };
                // 指定时间
                if (item.taskValidity == 2) {
                  objTask.startTime = item.startTime;
                  objTask.endTime = item.endTime;
                }
                // 商品
                if (item.skuIds) {
                  objTask.skuIds = item.skuIds.split(",");
                  let skuIdsLength = objTask.skuIds.length;
                  let skuIds = objTask.skuIds.toString();
                  goodsPromise.push(
                    getTaobaoItemListSku({
                      current: 1,
                      size: skuIdsLength,
                      skuIds: skuIds.split(","),
                    })
                  );
                }
                // 浏览会场-跳转链接
                if (item.taskType == 5) {
                  objTask.jumpUrl = item.jumpUrl;
                  objTask.viewTime = item.viewTime || 1;
                  objTask.giveLimit = item.giveLimit || 1;
                }
                // 搜索关键词
                if (item.taskType == 23) {
                  objTask.searchKeyword = item.searchKeyword;
                }
                // 好友助力-邀请人数上限
                if (item.taskType == 8) {
                  objTask.inviteLimit = item.inviteLimit;
                }
                if (item.taskType == 17) {
                  objTask.orderCountType = item.orderCountType;
                  objTask.orderType = item.orderType;
                  objTask.skuType = item.skuType;
                  // 指定商品规则回显，老数据无该字段时默认整单计算
                  objTask.statsSkuType = item.statsSkuType || 0;
                  objTask.itemTotalLimit = item.itemTotalLimit;
                  objTask.amtLimit = item.amtLimit;
                  objTask.orderStartTime = item.orderStartTime;
                  objTask.orderEndTime = item.orderEndTime;
                  objTask.giveType = item.giveType;
                  objTask.countType = item.countType;
                  objTask.taskDoType = item.taskDoType;
                  this.taskLevelList = item.stepList ? item.stepList : [];
                  this.selectGoodsSkuList = item.itemList;
                  objTask.selectGoodsSkuList = item.itemList;
                  objTask.venderIds =
                    item.venderIds
                      ? item.venderIds.split(",").map((item) => +item)
                      : [this.$store.getters.loginUserInfo.venderId];
                  objTask.sellerSkuList = item.sellerSkuList&&item.sellerSkuList.length?item.sellerSkuList:[{
                    skuIds: item.skuIds ? item.skuIds.split(",") : [],
                    venderId: this.$store.getters.loginUserInfo.venderId,
                    itemList: [],
                  }];
                  if (this.activityData.isCopy||this.isDraftEdit) {
                    // 跨店复制
                    if(objTask.venderIds.length>0) {
                      let index = objTask.venderIds.findIndex((item)=>{
                        return item == this.venderId
                      })
                      if(index==-1) {
                        objTask.venderIds.unshift(Number(this.venderId))
                        objTask.sellerSkuList.unshift({
                          venderId: Number(this.venderId),
                          skuIds: [],
                          itemList: [],
                        })
                      }
                    }
                  }
                  objTask.selectGoodsSkuList = item.itemList;
                  objTask.stepList = item.stepList;
                  objTask.orderPaymentType = item.orderPaymentType===null?1:item.orderPaymentType;
                  objTask.mergeOrder = item.mergeOrder || false;
                }
                if (item.taskType == 18) {
                  objTask.condition = item.inviteLimit;
                  objTask.condition2 = item.taskDoLimit;
                }
                // 任务门槛上限
                const taskTypeObj = this.taskTypeOptions.find(
                  (option) => option.value == item.taskType
                );
                if (this.conditionValue.includes(item.taskType)) {
                  if (item.taskType == 12 || item.taskType == 11) {
                    objTask.condition = item.giveLimit;
                    objTask.condition2 = item.taskDoLimit;
                  } else if (item.taskType == 4) {
                    objTask.condition = item.addCartLimit;
                    objTask.condition2 = item.taskDoLimit;
                  } else if (item.taskType == 16) {
                    objTask.condition = item.giveLimit;
                    objTask.condition2 = item.taskDoLimit;
                    objTask.activityType = item.activityType;
                  } else if (item.taskType == 17) {
                    objTask.activityType = 2;
                    objTask.condition = item.giveLimit;
                    objTask.condition2 = item.taskDoLimit;
                    objTask.count = taskTypeObj.taskCount;
                  } else {
                    objTask.condition = item.giveLimit;
                    objTask.count = taskTypeObj.taskCount;
                  }
                } else {
                  objTask.condition = taskTypeObj.taskCondition;
                  objTask.count = taskTypeObj.taskCount;
                }
                if(item.taskType == 7){
                  objTask.giveLimit = item.giveLimit
                }
                return objTask;
              });
              Promise.all(goodsPromise).then((res) => {
                this.taskDataList
                  .filter((item) => item.skuIds && item.skuIds.length)
                  .forEach((item, index) => {
                    item.selectGoodsSkuList = res[index].data.records;
                  });
              });
            }

            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;
              if (ruleDto.prizeType == 0) {
                this.prizeSettingList = pointActivityPrizeDTOList;
                this.prizeSettingList.forEach((item, index) => {
                  item.minNum = item.totalAmount;
                  item.index = index;
                  item.isWrite = false;
                  if (item.percentage) {
                    this.winningRate += Number(item.percentage);
                  }
                  // 提交地址限制回显：逗号分隔字符串转数字数组
                  if (item.prizeType == 3) {
                    if (item.commitAddressLimit) {
                      item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                        ? item.commitAddressLimit.split(',').map(Number)
                        : item.commitAddressLimit;
                    } else {
                      item.commitAddressLimit = [0];
                    }
                  }
                });
              } else {
                if (ruleDto.exchangeRule.prizeRule == 0) {
                  this.bigTurntableDrawPrizeDTOS = pointActivityPrizeDTOList;
                  this.bigTurntableDrawPrizeDTOS.forEach((item, index) => {
                    item.minNum = item.totalAmount;
                    item.index = index;
                    // 提交地址限制回显：逗号分隔字符串转数字数组
                    if (item.prizeType == 3) {
                      if (item.commitAddressLimit) {
                        item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                          ? item.commitAddressLimit.split(',').map(Number)
                          : item.commitAddressLimit;
                      } else {
                        item.commitAddressLimit = [0];
                      }
                    }
                  });
                } else {
                  this.stepList = [];
                  ruleDto.exchangeRule.stepList.forEach((item) => {
                    let stepData = {
                      taskIndex: item.taskIndex,
                      statisticsRule: item.statisticsRule,
                      collectSetNum:
                        item.statisticsRule == 0 ? item.collectSetNum : "",
                      collectCardNum:
                        item.statisticsRule == 1 ? item.collectCardNum : "",
                      stepPrizeDTO: [],
                    };
                    pointActivityPrizeDTOList.forEach((it) => {
                      if (it.taskIndex == stepData.taskIndex) {
                        // 提交地址限制回显：逗号分隔字符串转数字数组
                        if (it.prizeType == 3) {
                          if (it.commitAddressLimit) {
                            it.commitAddressLimit = typeof it.commitAddressLimit === 'string'
                              ? it.commitAddressLimit.split(',').map(Number)
                              : it.commitAddressLimit;
                          } else {
                            it.commitAddressLimit = [0];
                          }
                        }
                        stepData.stepPrizeDTO.push(it);
                      }
                    });
                    this.stepList.push(stepData);
                  });
                }
              }

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.selectGoodsArr = res.data.itemList;
              this.mainImagelist = res.data.itemList;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            this.winningRate = this.winningRate.toFixed(5);
            if (this.activityData.isCopy) {
              this.ruleForm.ruleDescription = "";
            }
          })
          .catch((res) => {
            this.loading = false;
          });
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      this.activityStartTime = null;
      this.activityEndTime = null;
    },
    // 清空任务时间
    clearTaskTime() {
      this.taskForm.startTime = "";
      this.taskForm.endTime = "";
    },
    // 清空下单时间
    clearOrderTime() {
      this.taskForm.orderStartTime = "";
      this.taskForm.orderEndTime = "";
    },
    // 控制大于0 - 正数可包含小数点
    validateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ""); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf(".");
      if (decimalIndex !== -1) {
        newValue =
          newValue.slice(0, decimalIndex + 1) +
          newValue.slice(decimalIndex + 1).replace(/\./g, "");
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = "999999.99"; // 设置为最大值
      }
      this.taskForm.amtLimit = newValue.replace(/^0+(\d)/, "$1");
    },
    validateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ""); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ""); // 移除前导零
        if (newValue === "") {
          newValue = "0";
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = "999"; // 设置为最大值
      }

      this.taskForm.itemTotalLimit = newValue;
    },

    // 控制大于0 - 正数可包含小数点
    inputValidateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ""); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf(".");
      if (decimalIndex !== -1) {
        newValue =
          newValue.slice(0, decimalIndex + 1) +
          newValue.slice(decimalIndex + 1).replace(/\./g, "");
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = "999999.99"; // 设置为最大值
      }
      return newValue.replace(/^0+(\d)/, "$1");
    },
    inputValidateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ""); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ""); // 移除前导零
        if (newValue === "") {
          newValue = "0";
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = "999"; // 设置为最大值
      }

      return newValue;
    },
    // 保留小数点后两位
    oninput2(val, $index, type = 1) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      let totalMemberBuyPercentage = 0;
      this.prizeSettingList.forEach((item, index) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
        if (type === 2) {
          totalMemberBuyPercentage += Number(item.memberBuyPercentage);
        }
        if ($index == index) {
          item.isWrite = true;
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // 入会且已购中奖率
      if (type === 2) {
        if (totalMemberBuyPercentage > 100) {
          val = String(100 - (totalMemberBuyPercentage - val));
        } else if (totalMemberBuyPercentage == 100) {
          if (val >= 100) {
            val = "100";
          } else {
            val = String(100 - (totalMemberBuyPercentage - val));
            if (val == 0) {
              val = "";
            }
          }
        }
      }

      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      if(type==2) {
        return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
      } else {
       return val ? val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d{1,5}).*$/, "$1$2.$3") : "";
      }
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
    // 新增任务
    addTask() {
      this.isTaskEdit = false;
      this.taskDialog = true;
      this.taskForm = {
        giveType: 0,
        countType: 1,
        taskDoType: 0,

        type: 1,
        taskTime: 1,
        condition: null,
        condition2: null,
        count: null,
        endTime: null,
        startTime: null,
        skuIds: [],
        selectGoodsSkuList: [],
        inviteLimit: null,
        jumpUrl: null,
        activityType: 2,
        skuType: 0,
        statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
        orderType: 0,
        orderCountType: 1,
        itemTotalLimit: null,
        amtLimit: null,
        orderEndTime: null,
        orderStartTime: null,
        venderIds: [],
        sellerSkuList: [],
        orderPaymentType: 1,
        mergeOrder: false,
      };
      this.selectGoodsSkuList = [];
      this.taskTypeChange(1);
    },
    // 关闭
    taskClose() {
      this.taskIsLook = false;
      this.taskDialog = false;
    },
    // 任务类型change
    taskTypeChange(e) {
      const obj = this.taskTypeOptions.find((item) => item.value == e);
      if (!this.conditionValue.includes(e)) {
        this.taskForm.condition = obj.taskCondition;
      } else {
        this.taskForm.condition = null;
        this.taskForm.condition2 = null;
        this.taskForm.activityType = 2;
      }
      // 任务次数
      if (e == 12) {
        this.taskForm.count = null;
      } else {
        this.taskForm.count = obj.taskCount;
      }
      // 购买商品 - tip：不能加入goodsTypeList 因为保存时不做限制
      if (this.taskForm.type == 17) {
        this.goodsLimit = 500
        this.initData();
        this.taskForm.skuIds = [];
        this.selectGoodsSkuList = [];
        this.taskForm.selectGoodsSkuList = [];
        this.taskForm.giveType = 0;
      } else {
        this.goodsLimit = 100
      }
      // 商品
      if (this.goodsTypeList.includes(e)) {
        this.taskForm.skuIds = [];
        this.selectGoodsSkuList = [];
        this.taskForm.selectGoodsSkuList = [];
      }
      this.taskForm.taskTime = 1;
    },
    // 校验阶梯设置的统计规则
    validateStepRules() {
      if (this.stepList.length <= 1) return true;

      // 检查集满套卡片的阶梯设置
      const setNumArr = this.stepList
        .filter((item) => item.statisticsRule === 0 && item.collectSetNum)
        .map((item) => parseFloat(item.collectSetNum));

      // 检查集满张卡片的阶梯设置
      const cardNumArr = this.stepList
        .filter((item) => item.statisticsRule === 1 && item.collectCardNum)
        .map((item) => parseFloat(item.collectCardNum));

      // 如果存在相同类型的阶梯设置，检查是否递增
      if (setNumArr.length > 1 && !this.isMonotonicIncreasing(setNumArr)) {
        this.$message.warning("下一个阶梯的集满套卡片数量需大于上一个阶梯");
        return false;
      }

      if (cardNumArr.length > 1 && !this.isMonotonicIncreasing(cardNumArr)) {
        this.$message.warning("下一个阶梯的集满张卡片数量需大于上一个阶梯");
        return false;
      }

      return true;
    },
    isMonotonicIncreasing(arr) {
      return arr.every((value, index, array) => {
        return index === 0 || parseFloat(value) > parseFloat(array[index - 1]);
      });
    },
    // 确认添加任务
    sureTask() {
      // 任务有效期
      if (this.taskForm.taskTime == 2) {
        if (!this.taskForm.startTime || !this.taskForm.startTime) {
          return this.$message.warning("请填写任务有效期");
        }
        if (this.taskForm.startTime && this.taskForm.endTime) {
          const startTime = new Date(
            this.taskForm.startTime + " 23:59:59"
          ).getTime();
          const endTime = new Date(
            this.taskForm.endTime + " 00:00:00"
          ).getTime();
          const activityStartTime = new Date(this.activityStartTime).getTime();
          const activityEndTime = new Date(this.activityEndTime).getTime();
          if (startTime > endTime) {
            return this.$message.warning("结束时间不能小于开始时间");
          }
          if (activityStartTime > startTime || endTime > activityEndTime) {
            return this.$message.warning(
              "任务有效期超出了活动时间范围，请重新选择"
            );
          }
        }
      }
      // 邀请人数上限
      if (this.taskForm.type == 8) {
        if (!this.taskForm.inviteLimit) {
          return this.$message.warning("请填写邀请人数上限");
        }
      }
      // 跳转链接
      if (this.taskForm.type == 5) {
        if (!this.taskForm.jumpUrl) {
          return this.$message.warning("请填写跳转链接");
        }
        if (!this.taskForm.viewTime) {
          return this.$message.warning("请输入浏览时间");
        }
        if (!this.taskForm.giveLimit) {
          return this.$message.warning("请输入奖励次数");
        }
      }
      // 搜索关键词
      if (this.taskForm.type == 23) {
        if (!this.taskForm.searchKeyword) {
          return this.$message.warning("请填写搜索关键词");
        }
      }
      // 购买商品类型
      if (this.taskForm.type == 17) {
        // 下单时间-------------
        if (!this.taskForm.orderStartTime || !this.taskForm.orderEndTime) {
          return this.$message.warning("请填写下单时间");
        }
        if (this.taskForm.orderStartTime && this.taskForm.orderEndTime) {
          const startTime = new Date(
            this.taskForm.orderStartTime + " 00:00:00"
          ).getTime();
          const endTime = new Date(
            this.taskForm.orderEndTime + " 00:00:00"
          ).getTime();
          if (startTime > endTime) {
            return this.$message.warning("下单结束时间不能小于下单开始时间");
          }
        }
        // 订单金额-------------
        if (!this.taskForm.amtLimit && this.taskForm.giveType == 0) {
          return this.$message.warning("请填写订单金额");
        }
        // 指定商品-------------
        // if (
        //   this.taskForm.skuType == 1 &&
        //   (!this.taskForm.skuIds.length || this.taskForm.skuIds.length < 1)
        // ) {
        //   return this.$message.warning("请选择指定商品");
        // }
        if (this.taskForm.skuType == 1) {
          const obj = this.taskForm.sellerSkuList.find((item) => {
            return item.skuIds.length == 0;
          });
          if (obj) {
            const shop = this.multiShopGoods.find((item) => {
              return item.venderId == obj.venderId;
            });
            return this.$message.warning(`请选择${shop.shopTitle}的指定商品`);
          }
        }
        if (this.taskForm.giveType == 1 || this.taskForm.giveType == 2) {
          let isLimit = false;
          let isLimitZero = false;
          this.taskLevelList.forEach((item) => {
            if (!item.limit || !item.giveNum) {
              isLimit = true;
            }
            if (item.limit == 0 && item.limit != "") {
              isLimitZero = true;
            }
          });
          if (isLimitZero) {
            return this.$message.warning("任务条件值需大于0");
          }
          if (isLimit) {
            return this.$message.warning("请填写任务条件");
          }
          if (!this.taskForm.condition2 && this.taskForm.taskDoType == 1) {
            return this.$message.warning("请填写任务次数");
          }
        }
        // 单笔订单-任务次数
        if (
          this.taskForm.orderCountType == 0 &&
          !this.taskForm.condition2 &&
          this.taskForm.giveType == 0
        ) {
          return this.$message.warning("请填写任务次数");
        }

        if (this.taskForm.giveType == 2) {
          let limitArr = [];
          let giveNumArr = [];
          this.taskLevelList.forEach((item) => {
            limitArr.push(item.limit);
            giveNumArr.push(item.giveNum);
          });
          if (!this.isMonotonicIncreasing(limitArr)) {
            return this.$message.warning("高级阶梯笔数需大于低级阶梯笔数");
          }
          if (!this.isMonotonicIncreasing(giveNumArr)) {
            return this.$message.warning(
              "高级阶梯抽奖机会需大于低级阶梯抽奖机会"
            );
          }
        }
        if (
          (this.taskForm.giveType == 1 || this.taskForm.giveType == 2) &&
          this.taskForm.taskDoType == 1
        ) {
          let number = 0;
          this.taskLevelList.forEach((item) => {
            number = Number(item.giveNum) + number;
          });
          if (Number(this.taskForm.condition2) < number) {
            return this.$message.warning(
              "任务次数不可低于任务条件可得抽奖机会"
            );
          }
        }
      }

      // 任务条件
      if (
        this.conditionValue.includes(this.taskForm.type) &&
        this.taskForm.type != 17
      ) {
        if (!this.taskForm.condition) {
          return this.$message.warning("请填写任务条件");
        }
      }
      // 商品
      if (this.goodsTypeList.includes(this.taskForm.type)) {
        if (this.taskForm.skuIds.length == 0) {
          const obj = this.taskTypeOptions.find(
            (item) => item.value == this.taskForm.type
          );
          return this.$message.warning(`请填写${obj.label}`);
        } else if (
          this.goodsLimitList.includes(this.taskForm.type) &&
          this.taskForm.condition > this.taskForm.skuIds.length
        ) {
          return this.$message.warning(
            `任务商品件数不得大于已选商品件数，请重新选择~`
          );
        }
      }
      // 任务次数
      if (
        this.taskForm.type == 18 ||
        this.taskForm.type == 12 ||
        this.taskForm.type == 16 ||
        this.taskForm.type == 4 ||
        this.taskForm.type == 11 ||
        (this.taskForm.type == 17 &&
          this.taskForm.orderCountType == 0 &&
          this.taskForm.giveType == 0)
      ) {
        if (!this.taskForm.condition2) {
          return this.$message.warning("请填写任务次数");
        }
      }
      if (this.taskForm.type == 7) {
        if (!this.taskForm.giveLimit) {
          return this.$message.warning(`请填写抽卡次数`);
        }
      }
      const obj = JSON.parse(JSON.stringify(this.taskForm));
      obj.stepList = JSON.parse(JSON.stringify(this.taskLevelList));
      const index = this.taskDataList.findIndex(
        (item) => item.type == this.taskForm.type
      );
      if (index != -1 && !this.isTaskEdit) {
        return this.$message.warning("列表已存在该类型任务，请勿重复添加~");
      } else {
        // 修改
        if (this.isTaskEdit) {
          const index = this.taskDataList.findIndex(
            (item) => item.type == this.taskRow.type
          );
          this.taskDataList.splice(index, 1, obj);
        } else {
          this.taskDataList.push(obj);
        }
      }
      this.taskDialog = false;
    },
    // 修改
    editTask(row, isLook) {
      const copyRow = JSON.parse(JSON.stringify(row));
      this.taskRow = row;
      this.isTaskEdit = true;
      this.taskForm = copyRow;
      // 指定商品规则兜底：老数据无该字段时默认整单计算
      this.taskForm.statsSkuType = copyRow.statsSkuType || 0;
      // 商品回显
      this.selectGoodsSkuList = copyRow.selectGoodsSkuList;
      this.taskDialog = true;

      this.taskIsLook = isLook;
      // 购买商品新增下单店铺回显处理
      if (this.taskForm.type == 17) {
        this.goodsLimit = 500
        this.initData();
        if(this.taskForm.skuType ==1) {
          const isReq = this.taskForm.sellerSkuList.some((item) => {
            return item.itemList&&item.itemList.length>0;
          });
          if (!isReq) {
            const reqList = this.taskForm.sellerSkuList.map((item) => {
              return getTaobaoItemListSku({
                current: 1,
                size: item.skuIds.length,
                skuIds: item.skuIds,
                venderId: item.venderId,
              });
            });
            Promise.all(reqList).then((res) => {
              res.forEach((itemRes, index) => {
                this.taskForm.sellerSkuList[index].itemList = itemRes.data.records;
              });
            });
          }
        }
      } else {
        this.goodsLimit = 100
      }
    },
    // 删除
    deleteTask(row) {
      const index = this.taskDataList.findIndex(
        (item) => item.type == row.type
      );
      this.taskDataList.splice(index, 1);
    },
    // 上移
    upTask(index) {
      this.taskDataList[index] = this.taskDataList.splice(
        index - 1,
        1,
        this.taskDataList[index]
      )[0];
    },
    // 下移
    downTask(index) {
      this.taskDataList[index] = this.taskDataList.splice(
        index + 1,
        1,
        this.taskDataList[index]
      )[0];
    },
    // 商品组件回调
    selectGoodsChange(val) {
      if (val) {
        let isGoods = false;
        val.forEach((item) => {
          if (item.skuStatus != 1) {
            isGoods = true;
          }
        });
        if(this.isPremissionShow){
          if (isGoods) {
             return this.$message.warning("当前所选商品包含下架商品，请重新选择");
          }
        }
 
        let valArr = [];
        this.selectGoodsSkuList = val;
        this.taskForm.selectGoodsSkuList = val;
        val.forEach((i) => {
          valArr.push(i.skuId);
        });
        this.taskForm.skuIds = valArr;
      }
      this.goodsState = false;
    },
    // 商品弹窗
    showGoods(limit = 100) {
      this.goodsLimit = limit;
      this.goodsState = true;
    },
    // 每日发放限额弹窗
    setLimit(row) {
      if (!row.totalAmount) {
        return this.$message.warning("请先输入奖品总数");
      }
      this.showLimitDialog = true;
      this.limitData = row;
    },
    // 每日发放限额弹窗确认
    handleLimitConfirm(data) {
      this.$set(this.limitData, "dailyLimitType", data.dailyLimitType);
      this.$set(this.limitData, "dailyLimit", data.dailyLimit);
      this.$set(this.limitData, "idleLimit", data.idleLimit);
      this.$set(this.limitData, "busyLimit", data.busyLimit);

      if (data.dailyLimitType == 0) {
        // 每日发放
        this.$delete(this.limitData, "idleLimit");
        this.$delete(this.limitData, "busyLimit");
      } else if (data.dailyLimitType == 1) {
        // 按闲忙时配置数量
        this.$delete(this.limitData, "dailyLimit");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-list-container {
  display: flex;
  flex-wrap: wrap;
  gap: 25px 50px;
  margin-top: 15px;
}
.card-item {
  border-radius: 4px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .upload-container {
    box-sizing: border-box;
    position: relative;
    .img-uploader {
      width: 186px;
      height: 274px;
      border: 1px solid #d9d9d9;
      position: relative;
      overflow: hidden;
      border-radius: 24px !important;
      /deep/ .el-upload {
        width: 186px;
        height: 274px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none !important;
      }

      /deep/ .el-upload-list--picture-card .el-upload-list__item {
        width: 100%;
        height: 274px;
        border: none;
        background-color: #fff;
      }
    }
    .hide-upload-btn {
      border: none;
      /deep/ .el-upload--picture-card {
        display: none !important;
      }
    }
    .del-icon {
      width: 34px;
      height: 24px;
      position: absolute;
      top: -10px;
      right: -16px;
      cursor: pointer;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
  .input-box {
    width: 210px;
  }
  .num-input {
    width: 160px;
  }
  .mt8 {
    width: 100%;
    margin-top: 10px;
  }
  .mtb8 {
    width: 100%;
    margin: 10px 0;
  }
  .w100 {
    width: 100%;
  }
}
.num-style {
  width: 90px;
  margin: 0 8px;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  // margin: 11px 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #fe4d45;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #fe4d45;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #fe4d45;
      color: #fe4d45;
      transition: all 0.2s;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    .rule-tip {
      margin-top: 8px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      // font-family: system-ui;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.task-wrap {
  display: flex;
  align-items: center;
  &-radio {
    margin-right: 10px;
  }
}
.book-good-wrap {
  display: flex;
  align-items: center;
}
.tip-red {
  color: red;
}
.task-tip-wrap {
  padding-right: 10%;
}
.skuType-label {
  /deep/ .el-form-item__label {
    padding-right: 3px;
  }
}

.mb12 {
  margin: 0 0 30px 24px;
}
.ml8 {
  margin-left: 8px;
}
.mt8 {
  margin-top: 8px;
}

.ml10 {
  margin-left: 10px;
}
.input-limit {
  width: 90px;
}
.label-left {
  margin-left: 8px;
}

.ladder-box {
  margin-top: 12px;
  padding: 12px;
  background-color: #f5f7fa;
  position: relative;
  .delete-icon {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    &:hover {
      color: red;
    }
  }
}
/deep/
  .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.btn-bg {
  margin-top: 5px;
  width: 80px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss">
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.task-btn-wrap {
  margin-bottom: 16px;
}
.task-tip {
  margin-bottom: 16px;
}

.rule_box {
  // width: 1000px;
  // height: 217px;
  background: #fcfcfc;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 0 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
</style>
